import { apiRTK as api } from "./src/apiRTK";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMcbimSpaces: build.query<
      GetMcbimSpacesApiResponse,
      GetMcbimSpacesApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/spaces`,
        params: {
          projectNo: queryArg.projectNo,
          jobId: queryArg.jobId,
          floorGlobalId: queryArg.floorGlobalId,
        },
      }),
    }),
    getMcbimSpacesInProject: build.query<
      GetMcbimSpacesInProjectApiResponse,
      GetMcbimSpacesInProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/spaces.in.project`,
        params: {
          projectNo: queryArg.projectNo,
          longName: queryArg.longName,
        },
      }),
    }),
    getMcbimItem: build.query<GetMcbimItemApiResponse, GetMcbimItemApiArg>({
      query: (queryArg) => ({
        url: `/mcbim/item`,
        params: {
          projectNo: queryArg.projectNo,
          itemId: queryArg.itemId,
        },
      }),
    }),
    getMcbimItemsInSpace: build.query<
      GetMcbimItemsInSpaceApiResponse,
      GetMcbimItemsInSpaceApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/items.in.space`,
        params: {
          spaceId: queryArg.spaceId,
          spaceName: queryArg.spaceName,
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimFileFloorVersions: build.query<
      GetMcbimFileFloorVersionsApiResponse,
      GetMcbimFileFloorVersionsApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/file.floor.versions`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimSingleMcbimSpace: build.query<
      GetMcbimSingleMcbimSpaceApiResponse,
      GetMcbimSingleMcbimSpaceApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/single-mcbim-space`,
        params: {
          projectNo: queryArg.projectNo,
          name: queryArg.name,
        },
      }),
    }),
    postMcbimItems: build.query<
      PostMcbimItemsApiResponse,
      PostMcbimItemsApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/items`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMcbimBuildingStories: build.query<
      GetMcbimBuildingStoriesApiResponse,
      GetMcbimBuildingStoriesApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/building-stories`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimDisciplines: build.query<
      GetMcbimDisciplinesApiResponse,
      GetMcbimDisciplinesApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/disciplines`,
        params: {
          projectNo: queryArg.projectNo,
          buildingStoryName: queryArg.buildingStoryName,
        },
      }),
    }),
    postMcbimTrendByKey: build.query<
      PostMcbimTrendByKeyApiResponse,
      PostMcbimTrendByKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/trend-by-key`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMcbimItemsUniqueClasses: build.query<
      GetMcbimItemsUniqueClassesApiResponse,
      GetMcbimItemsUniqueClassesApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/items/unique-classes`,
        params: {
          projectNo: queryArg.projectNo,
          buildingStoryName: queryArg.buildingStoryName,
        },
      }),
    }),
    getMcbimCeilingLines: build.query<
      GetMcbimCeilingLinesApiResponse,
      GetMcbimCeilingLinesApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/ceiling-lines`,
        params: {
          projectNo: queryArg.projectNo,
          jobId: queryArg.jobId,
          floorGlobalId: queryArg.floorGlobalId,
        },
      }),
    }),
    getMcbimPipeSeries: build.query<
      GetMcbimPipeSeriesApiResponse,
      GetMcbimPipeSeriesApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/pipe-series`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimFrags: build.query<GetMcbimFragsApiResponse, GetMcbimFragsApiArg>({
      query: (queryArg) => ({
        url: `/mcbim/frags`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMultiplacerRooms: build.query<
      PostMultiplacerRoomsApiResponse,
      PostMultiplacerRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerSingleRoom: build.query<
      GetMultiplacerSingleRoomApiResponse,
      GetMultiplacerSingleRoomApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/single-room`,
        params: {
          roomNumber: queryArg.roomNumber,
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMultiplacerStandardRooms: build.query<
      GetMultiplacerStandardRoomsApiResponse,
      GetMultiplacerStandardRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/standard-rooms`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    putMultiplacerRoomLock: build.mutation<
      PutMultiplacerRoomLockApiResponse,
      PutMultiplacerRoomLockApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/lock`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomCeiling: build.mutation<
      PostMultiplacerRoomCeilingApiResponse,
      PostMultiplacerRoomCeilingApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/ceiling`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerAirflowsImport: build.mutation<
      PostMultiplacerAirflowsImportApiResponse,
      PostMultiplacerAirflowsImportApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/airflows/import`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteMultiplacerRoomValidation: build.mutation<
      DeleteMultiplacerRoomValidationApiResponse,
      DeleteMultiplacerRoomValidationApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation`,
        method: "DELETE",
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMultiplacerRoomValidationDecisionStatus: build.mutation<
      PostMultiplacerRoomValidationDecisionStatusApiResponse,
      PostMultiplacerRoomValidationDecisionStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation-decision/status`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomValidationDecisionComment: build.mutation<
      PostMultiplacerRoomValidationDecisionCommentApiResponse,
      PostMultiplacerRoomValidationDecisionCommentApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation-decision/comment`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomValidationDecisionCommentUpdate: build.mutation<
      PostMultiplacerRoomValidationDecisionCommentUpdateApiResponse,
      PostMultiplacerRoomValidationDecisionCommentUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation-decision/comment/update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomValidationDecisionCommentDelete: build.mutation<
      PostMultiplacerRoomValidationDecisionCommentDeleteApiResponse,
      PostMultiplacerRoomValidationDecisionCommentDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation-decision/comment/delete`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomCeilingComment: build.mutation<
      PostMultiplacerRoomCeilingCommentApiResponse,
      PostMultiplacerRoomCeilingCommentApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/ceiling-comment`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomCeilingCommentUpdate: build.mutation<
      PostMultiplacerRoomCeilingCommentUpdateApiResponse,
      PostMultiplacerRoomCeilingCommentUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/ceiling-comment/update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomCeilingCommentDelete: build.mutation<
      PostMultiplacerRoomCeilingCommentDeleteApiResponse,
      PostMultiplacerRoomCeilingCommentDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/ceiling-comment/delete`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomSnapshotTrendByKey: build.query<
      PostMultiplacerRoomSnapshotTrendByKeyApiResponse,
      PostMultiplacerRoomSnapshotTrendByKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room-snapshot/trend-by-key`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomsUpdateCalculatedRoomNumbers: build.mutation<
      PostMultiplacerRoomsUpdateCalculatedRoomNumbersApiResponse,
      PostMultiplacerRoomsUpdateCalculatedRoomNumbersApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/update-calculated-room-numbers`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putMultiplacerRoomsRoomNumberingManualValue: build.mutation<
      PutMultiplacerRoomsRoomNumberingManualValueApiResponse,
      PutMultiplacerRoomsRoomNumberingManualValueApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/manual-value`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteMultiplacerRoomsRoomNumberingManualValue: build.mutation<
      DeleteMultiplacerRoomsRoomNumberingManualValueApiResponse,
      DeleteMultiplacerRoomsRoomNumberingManualValueApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/manual-value`,
        method: "DELETE",
        params: {
          projectNo: queryArg.projectNo,
          roomNumber: queryArg.roomNumber,
        },
      }),
    }),
    postMultiplacerRoomsRoomNumberingApproval: build.mutation<
      PostMultiplacerRoomsRoomNumberingApprovalApiResponse,
      PostMultiplacerRoomsRoomNumberingApprovalApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/approval`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteMultiplacerRoomsRoomNumberingApproval: build.mutation<
      DeleteMultiplacerRoomsRoomNumberingApprovalApiResponse,
      DeleteMultiplacerRoomsRoomNumberingApprovalApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/approval`,
        method: "DELETE",
        params: {
          projectNo: queryArg.projectNo,
          roomNumber: queryArg.roomNumber,
        },
      }),
    }),
    postMultiplacerRoomsRoomNumberingApprovalBulk: build.mutation<
      PostMultiplacerRoomsRoomNumberingApprovalBulkApiResponse,
      PostMultiplacerRoomsRoomNumberingApprovalBulkApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/approval/bulk`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomsRoomNumberingApprovalBulkClear: build.mutation<
      PostMultiplacerRoomsRoomNumberingApprovalBulkClearApiResponse,
      PostMultiplacerRoomsRoomNumberingApprovalBulkClearApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/approval/bulk-clear`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDevices: build.query<
      PostMultiplacerDevicesApiResponse,
      PostMultiplacerDevicesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devices`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDevicesSimilarRoomsWithIfcDesign: build.query<
      PostMultiplacerDevicesSimilarRoomsWithIfcDesignApiResponse,
      PostMultiplacerDevicesSimilarRoomsWithIfcDesignApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devices/similar-rooms-with-ifc-design`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDevicesSimilarRoomsWithDevices: build.query<
      PostMultiplacerDevicesSimilarRoomsWithDevicesApiResponse,
      PostMultiplacerDevicesSimilarRoomsWithDevicesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devices/similar-rooms-with-devices`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putMultiplacerDeviceUpdate: build.mutation<
      PutMultiplacerDeviceUpdateApiResponse,
      PutMultiplacerDeviceUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/device/update`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDeviceAddDevices: build.mutation<
      PostMultiplacerDeviceAddDevicesApiResponse,
      PostMultiplacerDeviceAddDevicesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/device/add-devices`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerMediaAssets: build.query<
      GetMultiplacerMediaAssetsApiResponse,
      GetMultiplacerMediaAssetsApiArg
    >({
      query: () => ({ url: `/multiplacer/media-assets` }),
    }),
    deleteMultiplacerMediaAssetsByKey: build.mutation<
      DeleteMultiplacerMediaAssetsByKeyApiResponse,
      DeleteMultiplacerMediaAssetsByKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/media-assets/${queryArg.key}`,
        method: "DELETE",
      }),
    }),
    getMultiplacerMediaAssetsMediaAssetKey: build.query<
      GetMultiplacerMediaAssetsMediaAssetKeyApiResponse,
      GetMultiplacerMediaAssetsMediaAssetKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/media-assets/:mediaAssetKey`,
        params: {
          mediaAssetKey: queryArg.mediaAssetKey,
        },
      }),
    }),
    postMultiplacerDeviceDeleteInRooms: build.mutation<
      PostMultiplacerDeviceDeleteInRoomsApiResponse,
      PostMultiplacerDeviceDeleteInRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/device/delete-in-rooms`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteMultiplacerDeviceDeleteDevice: build.mutation<
      DeleteMultiplacerDeviceDeleteDeviceApiResponse,
      DeleteMultiplacerDeviceDeleteDeviceApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/device/delete-device`,
        method: "DELETE",
        params: {
          deviceId: queryArg.deviceId,
        },
      }),
    }),
    getAuthMe: build.query<GetAuthMeApiResponse, GetAuthMeApiArg>({
      query: () => ({ url: `/auth/me` }),
    }),
    getAuthUsersByUserIdProfilePhoto: build.query<
      GetAuthUsersByUserIdProfilePhotoApiResponse,
      GetAuthUsersByUserIdProfilePhotoApiArg
    >({
      query: (queryArg) => ({
        url: `/auth/users/${queryArg.userId}/profile-photo`,
      }),
    }),
    getProjectSyncRuns: build.query<
      GetProjectSyncRunsApiResponse,
      GetProjectSyncRunsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/sync-runs`,
        params: {
          projectNo: queryArg.projectNo,
          limit: queryArg.limit,
          cursor: queryArg.cursor,
        },
      }),
    }),
    getMultiplacerAssetsSas: build.query<
      GetMultiplacerAssetsSasApiResponse,
      GetMultiplacerAssetsSasApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/assets/sas`,
        params: {
          target: queryArg.target,
          blobPath: queryArg.blobPath,
        },
      }),
    }),
    getMultiplacerDrofusInterfaceOccurrencesSyncSchedule: build.query<
      GetMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiResponse,
      GetMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/occurrences-sync-schedule`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMultiplacerDrofusInterfaceOccurrencesSyncSchedule: build.mutation<
      PostMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiResponse,
      PostMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/occurrences-sync-schedule`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerDrofusInterfaceRuns: build.query<
      GetMultiplacerDrofusInterfaceRunsApiResponse,
      GetMultiplacerDrofusInterfaceRunsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/runs`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
          projectNo: queryArg.projectNo,
          status: queryArg.status,
        },
      }),
    }),
    postMultiplacerDrofusInterfaceDeleteRun: build.mutation<
      PostMultiplacerDrofusInterfaceDeleteRunApiResponse,
      PostMultiplacerDrofusInterfaceDeleteRunApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/delete-run`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDrofusInterfaceOccurrences: build.query<
      PostMultiplacerDrofusInterfaceOccurrencesApiResponse,
      PostMultiplacerDrofusInterfaceOccurrencesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/occurrences`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDrofusInterfaceArticles: build.query<
      PostMultiplacerDrofusInterfaceArticlesApiResponse,
      PostMultiplacerDrofusInterfaceArticlesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/articles`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postTdroomUpsert: build.mutation<
      PostTdroomUpsertApiResponse,
      PostTdroomUpsertApiArg
    >({
      query: (queryArg) => ({
        url: `/tdroom/upsert`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getTdroomSingle: build.query<
      GetTdroomSingleApiResponse,
      GetTdroomSingleApiArg
    >({
      query: (queryArg) => ({
        url: `/tdroom/single`,
        params: {
          tdroomId: queryArg.tdroomId,
        },
      }),
    }),
    getTdroomAll: build.query<GetTdroomAllApiResponse, GetTdroomAllApiArg>({
      query: () => ({ url: `/tdroom/all` }),
    }),
    postAddProjectTdRooms: build.mutation<
      PostAddProjectTdRoomsApiResponse,
      PostAddProjectTdRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/add-project-td-rooms`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerDevicetypes: build.query<
      GetMultiplacerDevicetypesApiResponse,
      GetMultiplacerDevicetypesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devicetypes`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMultiplacerDevicetypesAggregate: build.mutation<
      PostMultiplacerDevicetypesAggregateApiResponse,
      PostMultiplacerDevicetypesAggregateApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devicetypes.aggregate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerDevicetypesStats: build.query<
      GetMultiplacerDevicetypesStatsApiResponse,
      GetMultiplacerDevicetypesStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devicetypes.stats`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMlPredictCeilingDevices: build.mutation<
      PostMlPredictCeilingDevicesApiResponse,
      PostMlPredictCeilingDevicesApiArg
    >({
      query: (queryArg) => ({
        url: `/ml/predict-ceiling-devices`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMlPing: build.query<GetMlPingApiResponse, GetMlPingApiArg>({
      query: () => ({ url: `/ml/ping` }),
    }),
    postMultiplacerProjectAddProject: build.mutation<
      PostMultiplacerProjectAddProjectApiResponse,
      PostMultiplacerProjectAddProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/project/add-project`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerProjects: build.query<
      GetMultiplacerProjectsApiResponse,
      GetMultiplacerProjectsApiArg
    >({
      query: () => ({ url: `/multiplacer/projects` }),
    }),
    postProjectDrofusUpdateSettings: build.mutation<
      PostProjectDrofusUpdateSettingsApiResponse,
      PostProjectDrofusUpdateSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/drofus.update-settings`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerProjectsSingleProject: build.query<
      GetMultiplacerProjectsSingleProjectApiResponse,
      GetMultiplacerProjectsSingleProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/projects/single-project`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMultiplacerProjectEditProject: build.mutation<
      PostMultiplacerProjectEditProjectApiResponse,
      PostMultiplacerProjectEditProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/project/edit-project`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectVentilationUpdateSettings: build.mutation<
      PostProjectVentilationUpdateSettingsApiResponse,
      PostProjectVentilationUpdateSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/ventilation.update-settings`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerProjectsAddMember: build.mutation<
      PostMultiplacerProjectsAddMemberApiResponse,
      PostMultiplacerProjectsAddMemberApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/projects/add-member`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerProjectsInviteByEmail: build.mutation<
      PostMultiplacerProjectsInviteByEmailApiResponse,
      PostMultiplacerProjectsInviteByEmailApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/projects/invite-by-email`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    ping: build.query<PingApiResponse, PingApiArg>({
      query: () => ({ url: `/ping` }),
    }),
    getFunctionsPing: build.query<
      GetFunctionsPingApiResponse,
      GetFunctionsPingApiArg
    >({
      query: () => ({ url: `/functions/ping` }),
    }),
    postMultiplacerEnrichRoom: build.mutation<
      PostMultiplacerEnrichRoomApiResponse,
      PostMultiplacerEnrichRoomApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/enrich-room`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerSyncStart: build.mutation<
      PostMultiplacerSyncStartApiResponse,
      PostMultiplacerSyncStartApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/sync/start`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectDrofusVerifyConnection: build.mutation<
      PostProjectDrofusVerifyConnectionApiResponse,
      PostProjectDrofusVerifyConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/project/drofus.verify-connection`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDrofusInterfaceOccurrencesSync: build.mutation<
      PostMultiplacerDrofusInterfaceOccurrencesSyncApiResponse,
      PostMultiplacerDrofusInterfaceOccurrencesSyncApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/occurrences/sync`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postSharedZodPing: build.mutation<
      PostSharedZodPingApiResponse,
      PostSharedZodPingApiArg
    >({
      query: (queryArg) => ({
        url: `/shared/zod-ping`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getSharedStaticDeviceTypeSettings: build.query<
      GetSharedStaticDeviceTypeSettingsApiResponse,
      GetSharedStaticDeviceTypeSettingsApiArg
    >({
      query: () => ({ url: `/shared/static/device-type-settings` }),
    }),
    postMultiplacerReleaseNotesDeployNotes: build.mutation<
      PostMultiplacerReleaseNotesDeployNotesApiResponse,
      PostMultiplacerReleaseNotesDeployNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/release-notes/deploy-notes`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerReleaseNotesPublished: build.query<
      GetMultiplacerReleaseNotesPublishedApiResponse,
      GetMultiplacerReleaseNotesPublishedApiArg
    >({
      query: () => ({ url: `/multiplacer/release-notes/published` }),
    }),
    getMultiplacerReleaseNotesDeployNotesUnpublished: build.query<
      GetMultiplacerReleaseNotesDeployNotesUnpublishedApiResponse,
      GetMultiplacerReleaseNotesDeployNotesUnpublishedApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/release-notes/deploy-notes/unpublished`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
          module: queryArg["module"],
        },
      }),
    }),
    postMultiplacerReleaseNotesPublish: build.mutation<
      PostMultiplacerReleaseNotesPublishApiResponse,
      PostMultiplacerReleaseNotesPublishApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/release-notes/publish`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteMultiplacerReleaseNotesDeployNotesByDeployNoteIdChangeItemsAndChangeItemIdMedia:
      build.mutation<
        DeleteMultiplacerReleaseNotesDeployNotesByDeployNoteIdChangeItemsAndChangeItemIdMediaApiResponse,
        DeleteMultiplacerReleaseNotesDeployNotesByDeployNoteIdChangeItemsAndChangeItemIdMediaApiArg
      >({
        query: (queryArg) => ({
          url: `/multiplacer/release-notes/deploy-notes/${queryArg.deployNoteId}/change-items/${queryArg.changeItemId}/media`,
          method: "DELETE",
          params: {
            blobPath: queryArg.blobPath,
          },
        }),
      }),
    getMultiplacerReleaseNotesStatus: build.query<
      GetMultiplacerReleaseNotesStatusApiResponse,
      GetMultiplacerReleaseNotesStatusApiArg
    >({
      query: () => ({ url: `/multiplacer/release-notes/status` }),
    }),
    postMultiplacerReleaseNotesMarkSeen: build.mutation<
      PostMultiplacerReleaseNotesMarkSeenApiResponse,
      PostMultiplacerReleaseNotesMarkSeenApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/release-notes/mark-seen`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getRoutingGraphList: build.query<
      GetRoutingGraphListApiResponse,
      GetRoutingGraphListApiArg
    >({
      query: (queryArg) => ({
        url: `/routing/graph/list`,
        params: {
          projectNo: queryArg.projectNo,
          floorName: queryArg.floorName,
        },
      }),
    }),
    postRoutingGraphSave: build.mutation<
      PostRoutingGraphSaveApiResponse,
      PostRoutingGraphSaveApiArg
    >({
      query: (queryArg) => ({
        url: `/routing/graph/save`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteRoutingGraphDelete: build.mutation<
      DeleteRoutingGraphDeleteApiResponse,
      DeleteRoutingGraphDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/routing/graph/delete`,
        method: "DELETE",
        params: {
          graphId: queryArg.graphId,
        },
      }),
    }),
    getMcappsProjectPns: build.query<
      GetMcappsProjectPnsApiResponse,
      GetMcappsProjectPnsApiArg
    >({
      query: (queryArg) => ({
        url: `/mcapps/project/pns`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as openapi };
export type GetMcbimSpacesApiResponse = /** status 200 Successful response */ {
  _id?: any;
  buildingStory: {
    elevation?: number;
    expressId?: number;
    globalId: string;
    name: string;
  } | null;
  fileName: string;
  globalId: string;
  longName?: string;
  name: string;
  polygon?: number[][];
  ceilingGrids?: {
    lines: number[][][];
    /** 3D point represented as [x, y, z] */
    intersectionPoint?: number[];
    /** 3D point represented as [x, y, z] */
    direction?: number[];
    tileSize?: number[];
    interiorLines?: number[][][];
    edgePolygon?: number[][];
    floorHeightMm?: number;
    floorHeightM?: number;
    worldHeightMm?: number;
    worldHeightM?: number;
  }[];
}[];
export type GetMcbimSpacesApiArg = {
  projectNo: number;
  jobId: string;
  floorGlobalId?: string;
};
export type GetMcbimSpacesInProjectApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    globalId: string;
    buildingStory: {
      elevation?: number;
      expressId?: number;
      globalId: string;
      name: string;
    } | null;
    instanceClass: string;
    expressId: number;
    predefinedType?: (string | number) | null;
    geometry?: {
      polygon2d?: number[][];
      bbox2d?: number[][];
      centerPoint2d?: number[];
      Obb3DWorldMmList?: {
        centerMm: {
          x: number;
          y: number;
          z: number;
        };
        centerM?: {
          x: number;
          y: number;
          z: number;
        };
        axisA: {
          x: number;
          y: number;
          z: number;
        };
        axisB: {
          x: number;
          y: number;
          z: number;
        };
        axisC: {
          x: number;
          y: number;
          z: number;
        };
        extentAMm: number;
        extentBMm: number;
        extentCMm: number;
        extentAM?: number;
        extentBM?: number;
        extentCM?: number;
      }[];
      zWorldMm?: {
        bottom: number;
        middle: number;
        top: number;
      };
      zWorldM?: {
        bottom: number;
        middle: number;
        top: number;
      };
      heightMm?: number;
      heightM?: number;
      floorZWorldMm?: number;
      floorZWorldM?: number;
      floorSource?: "buildingStorey" | "unknown";
      zRelMm?: {
        bottom: number;
        middle: number;
        top: number;
      };
      zRelM?: {
        bottom: number;
        middle: number;
        top: number;
      };
    };
    geometryVersion?: number;
    fileAttr1?: string;
    fileAttr2?: string;
    fileAttr3?: string;
    fileAttr4?: string;
    fileFolderId?: string;
    fileIfcSchema: string;
    fileIsLatest: boolean;
    fileLastModifiedBy: string;
    fileName: string;
    filePath: string;
    fileStorageId: string;
    fileUploadedAt: string;
    includedMaterials?: {
      [key: string]: boolean;
    };
    insertedAt: string;
    longName?: string;
    materials?: {
      [key: string]: number;
    }[];
    name: string;
    description: string;
    building?: string;
    job: {
      jobId?: any;
      createdAt: string;
    };
    bbox?: number[][];
    polygon?: number[][];
    centerPoint?: number[];
    psets: {
      [key: string]: {
        [key: string]: (string | number) | boolean;
      };
    };
    type: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    } | null;
    ceilingGrids?: {
      lines: number[][][];
      /** 3D point represented as [x, y, z] */
      intersectionPoint?: number[];
      /** 3D point represented as [x, y, z] */
      direction?: number[];
      tileSize?: number[];
      interiorLines?: number[][][];
      edgePolygon?: number[][];
      floorHeightMm?: number;
      floorHeightM?: number;
      worldHeightMm?: number;
      worldHeightM?: number;
    }[];
    error2d?: {
      message: string;
      stack: string;
    };
    geometryExtractedFromTypeGlobalId?: string;
    elementMaterials?: {
      name: string;
      thickness: number;
      calculatedVolume?: number;
    }[];
    primarySystem?: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    } | null;
    systems?: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    }[];
  }[];
export type GetMcbimSpacesInProjectApiArg = {
  projectNo: number;
  longName?: string;
};
export type GetMcbimItemApiResponse = /** status 200 Successful response */ {
  _id?: any;
  globalId: string;
  buildingStory: {
    elevation?: number;
    expressId?: number;
    globalId: string;
    name: string;
  } | null;
  instanceClass: string;
  expressId: number;
  predefinedType?: (string | number) | null;
  geometry?: {
    polygon2d?: number[][];
    bbox2d?: number[][];
    centerPoint2d?: number[];
    Obb3DWorldMmList?: {
      centerMm: {
        x: number;
        y: number;
        z: number;
      };
      centerM?: {
        x: number;
        y: number;
        z: number;
      };
      axisA: {
        x: number;
        y: number;
        z: number;
      };
      axisB: {
        x: number;
        y: number;
        z: number;
      };
      axisC: {
        x: number;
        y: number;
        z: number;
      };
      extentAMm: number;
      extentBMm: number;
      extentCMm: number;
      extentAM?: number;
      extentBM?: number;
      extentCM?: number;
    }[];
    zWorldMm?: {
      bottom: number;
      middle: number;
      top: number;
    };
    zWorldM?: {
      bottom: number;
      middle: number;
      top: number;
    };
    heightMm?: number;
    heightM?: number;
    floorZWorldMm?: number;
    floorZWorldM?: number;
    floorSource?: "buildingStorey" | "unknown";
    zRelMm?: {
      bottom: number;
      middle: number;
      top: number;
    };
    zRelM?: {
      bottom: number;
      middle: number;
      top: number;
    };
  };
  geometryVersion?: number;
  fileAttr1?: string;
  fileAttr2?: string;
  fileAttr3?: string;
  fileAttr4?: string;
  fileFolderId?: string;
  fileIfcSchema: string;
  fileIsLatest: boolean;
  fileLastModifiedBy: string;
  fileName: string;
  filePath: string;
  fileStorageId: string;
  fileUploadedAt: string;
  includedMaterials?: {
    [key: string]: boolean;
  };
  insertedAt: string;
  longName?: string;
  materials?: {
    [key: string]: number;
  }[];
  name: string;
  description: string;
  building?: string;
  job: {
    jobId?: any;
    createdAt: string;
  };
  bbox?: number[][];
  polygon?: number[][];
  centerPoint?: number[];
  psets: {
    [key: string]: {
      [key: string]: (string | number) | boolean;
    };
  };
  type: {
    globalId: string;
    name: string;
    typeClass: string;
    predefinedType?: (string | number) | null;
  } | null;
  ceilingGrids?: {
    lines: number[][][];
    /** 3D point represented as [x, y, z] */
    intersectionPoint?: number[];
    /** 3D point represented as [x, y, z] */
    direction?: number[];
    tileSize?: number[];
    interiorLines?: number[][][];
    edgePolygon?: number[][];
    floorHeightMm?: number;
    floorHeightM?: number;
    worldHeightMm?: number;
    worldHeightM?: number;
  }[];
  error2d?: {
    message: string;
    stack: string;
  };
  geometryExtractedFromTypeGlobalId?: string;
  elementMaterials?: {
    name: string;
    thickness: number;
    calculatedVolume?: number;
  }[];
  primarySystem?: {
    globalId: string;
    name: string;
    typeClass: string;
    predefinedType?: (string | number) | null;
  } | null;
  systems?: {
    globalId: string;
    name: string;
    typeClass: string;
    predefinedType?: (string | number) | null;
  }[];
} | null;
export type GetMcbimItemApiArg = {
  projectNo: number;
  itemId: string;
};
export type GetMcbimItemsInSpaceApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    globalId: string;
    buildingStory: {
      elevation?: number;
      expressId?: number;
      globalId: string;
      name: string;
    } | null;
    instanceClass: string;
    expressId: number;
    predefinedType?: (string | number) | null;
    geometry?: {
      polygon2d?: number[][];
      bbox2d?: number[][];
      centerPoint2d?: number[];
      Obb3DWorldMmList?: {
        centerMm: {
          x: number;
          y: number;
          z: number;
        };
        centerM?: {
          x: number;
          y: number;
          z: number;
        };
        axisA: {
          x: number;
          y: number;
          z: number;
        };
        axisB: {
          x: number;
          y: number;
          z: number;
        };
        axisC: {
          x: number;
          y: number;
          z: number;
        };
        extentAMm: number;
        extentBMm: number;
        extentCMm: number;
        extentAM?: number;
        extentBM?: number;
        extentCM?: number;
      }[];
      zWorldMm?: {
        bottom: number;
        middle: number;
        top: number;
      };
      zWorldM?: {
        bottom: number;
        middle: number;
        top: number;
      };
      heightMm?: number;
      heightM?: number;
      floorZWorldMm?: number;
      floorZWorldM?: number;
      floorSource?: "buildingStorey" | "unknown";
      zRelMm?: {
        bottom: number;
        middle: number;
        top: number;
      };
      zRelM?: {
        bottom: number;
        middle: number;
        top: number;
      };
    };
    geometryVersion?: number;
    fileAttr1?: string;
    fileAttr2?: string;
    fileAttr3?: string;
    fileAttr4?: string;
    fileFolderId?: string;
    fileIfcSchema: string;
    fileIsLatest: boolean;
    fileLastModifiedBy: string;
    fileName: string;
    filePath: string;
    fileStorageId: string;
    fileUploadedAt: string;
    includedMaterials?: {
      [key: string]: boolean;
    };
    insertedAt: string;
    longName?: string;
    materials?: {
      [key: string]: number;
    }[];
    name: string;
    description: string;
    building?: string;
    job: {
      jobId?: any;
      createdAt: string;
    };
    bbox?: number[][];
    polygon?: number[][];
    centerPoint?: number[];
    psets: {
      [key: string]: {
        [key: string]: (string | number) | boolean;
      };
    };
    type: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    } | null;
    ceilingGrids?: {
      lines: number[][][];
      /** 3D point represented as [x, y, z] */
      intersectionPoint?: number[];
      /** 3D point represented as [x, y, z] */
      direction?: number[];
      tileSize?: number[];
      interiorLines?: number[][][];
      edgePolygon?: number[][];
      floorHeightMm?: number;
      floorHeightM?: number;
      worldHeightMm?: number;
      worldHeightM?: number;
    }[];
    error2d?: {
      message: string;
      stack: string;
    };
    geometryExtractedFromTypeGlobalId?: string;
    elementMaterials?: {
      name: string;
      thickness: number;
      calculatedVolume?: number;
    }[];
    primarySystem?: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    } | null;
    systems?: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    }[];
  }[];
export type GetMcbimItemsInSpaceApiArg = {
  spaceId?: string;
  spaceName?: string;
  projectNo: number;
};
export type GetMcbimFileFloorVersionsApiResponse =
  /** status 200 Successful response */ {
    building: string;
    buildingStoryName: string;
    buildingStoryGlobalId: string;
    jobId: string;
    createdAt: string;
    fileName: string;
  }[];
export type GetMcbimFileFloorVersionsApiArg = {
  projectNo: number;
};
export type GetMcbimSingleMcbimSpaceApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    globalId: string;
    buildingStory: {
      elevation?: number;
      expressId?: number;
      globalId: string;
      name: string;
    } | null;
    instanceClass: string;
    expressId: number;
    predefinedType?: (string | number) | null;
    geometry?: {
      polygon2d?: number[][];
      bbox2d?: number[][];
      centerPoint2d?: number[];
      Obb3DWorldMmList?: {
        centerMm: {
          x: number;
          y: number;
          z: number;
        };
        centerM?: {
          x: number;
          y: number;
          z: number;
        };
        axisA: {
          x: number;
          y: number;
          z: number;
        };
        axisB: {
          x: number;
          y: number;
          z: number;
        };
        axisC: {
          x: number;
          y: number;
          z: number;
        };
        extentAMm: number;
        extentBMm: number;
        extentCMm: number;
        extentAM?: number;
        extentBM?: number;
        extentCM?: number;
      }[];
      zWorldMm?: {
        bottom: number;
        middle: number;
        top: number;
      };
      zWorldM?: {
        bottom: number;
        middle: number;
        top: number;
      };
      heightMm?: number;
      heightM?: number;
      floorZWorldMm?: number;
      floorZWorldM?: number;
      floorSource?: "buildingStorey" | "unknown";
      zRelMm?: {
        bottom: number;
        middle: number;
        top: number;
      };
      zRelM?: {
        bottom: number;
        middle: number;
        top: number;
      };
    };
    geometryVersion?: number;
    fileAttr1?: string;
    fileAttr2?: string;
    fileAttr3?: string;
    fileAttr4?: string;
    fileFolderId?: string;
    fileIfcSchema: string;
    fileIsLatest: boolean;
    fileLastModifiedBy: string;
    fileName: string;
    filePath: string;
    fileStorageId: string;
    fileUploadedAt: string;
    includedMaterials?: {
      [key: string]: boolean;
    };
    insertedAt: string;
    longName?: string;
    materials?: {
      [key: string]: number;
    }[];
    name: string;
    description: string;
    building?: string;
    job: {
      jobId?: any;
      createdAt: string;
    };
    bbox?: number[][];
    polygon?: number[][];
    centerPoint?: number[];
    psets: {
      [key: string]: {
        [key: string]: (string | number) | boolean;
      };
    };
    type: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    } | null;
    ceilingGrids?: {
      lines: number[][][];
      /** 3D point represented as [x, y, z] */
      intersectionPoint?: number[];
      /** 3D point represented as [x, y, z] */
      direction?: number[];
      tileSize?: number[];
      interiorLines?: number[][][];
      edgePolygon?: number[][];
      floorHeightMm?: number;
      floorHeightM?: number;
      worldHeightMm?: number;
      worldHeightM?: number;
    }[];
    error2d?: {
      message: string;
      stack: string;
    };
    geometryExtractedFromTypeGlobalId?: string;
    elementMaterials?: {
      name: string;
      thickness: number;
      calculatedVolume?: number;
    }[];
    primarySystem?: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    } | null;
    systems?: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    }[];
  } | null;
export type GetMcbimSingleMcbimSpaceApiArg = {
  projectNo: number;
  name: string;
};
export type PostMcbimItemsApiResponse = /** status 200 Successful response */ {
  _id?: any;
  name: string;
  longName?: string;
  globalId: string;
  fileName: string;
  polygon?: number[][];
  bbox?: number[][];
  instanceClass: string;
  centerPoint?: number[];
  geometry?: {
    polygon2d?: number[][];
    bbox2d?: number[][];
    centerPoint2d?: number[];
    Obb3DWorldMmList?: {
      centerMm: {
        x: number;
        y: number;
        z: number;
      };
      centerM?: {
        x: number;
        y: number;
        z: number;
      };
      axisA: {
        x: number;
        y: number;
        z: number;
      };
      axisB: {
        x: number;
        y: number;
        z: number;
      };
      axisC: {
        x: number;
        y: number;
        z: number;
      };
      extentAMm: number;
      extentBMm: number;
      extentCMm: number;
      extentAM?: number;
      extentBM?: number;
      extentCM?: number;
    }[];
    zWorldMm?: {
      bottom: number;
      middle: number;
      top: number;
    };
    zWorldM?: {
      bottom: number;
      middle: number;
      top: number;
    };
    heightMm?: number;
    heightM?: number;
    floorZWorldMm?: number;
    floorZWorldM?: number;
    floorSource?: "buildingStorey" | "unknown";
    zRelMm?: {
      bottom: number;
      middle: number;
      top: number;
    };
    zRelM?: {
      bottom: number;
      middle: number;
      top: number;
    };
  };
  mmi?: string | null;
  compCode?: string | null;
  discipline?: string | null;
  system?: string | null;
  typeName?: string | null;
}[];
export type PostMcbimItemsApiArg = {
  body: {
    projectNo: number;
    buildingStoryName: string;
    instanceClasses?: string[];
    disciplines?: string[];
    centerPointBounds?: {
      minX: number;
      maxX: number;
      minY: number;
      maxY: number;
    };
  };
};
export type GetMcbimBuildingStoriesApiResponse =
  /** status 200 Successful response */ {
    elevation?: number;
    expressId?: number;
    globalId: string;
    name: string;
    building?: string | null;
    spaceCount: number;
    job: {
      jobId?: any;
      createdAt: string;
    };
  }[];
export type GetMcbimBuildingStoriesApiArg = {
  projectNo: number;
};
export type GetMcbimDisciplinesApiResponse =
  /** status 200 Successful response */ string[];
export type GetMcbimDisciplinesApiArg = {
  projectNo: number;
  buildingStoryName: string;
};
export type PostMcbimTrendByKeyApiResponse =
  /** status 200 Successful response */ {
    date: string;
    series: {
      value?: any;
      count: number;
    }[];
    total: number;
  }[];
export type PostMcbimTrendByKeyApiArg = {
  body: {
    projectNo: number;
    keyPath: string;
    filter: {
      instanceClasses?: string[];
      names?: string[];
      globalId?: string;
      dateFrom: string;
      dateTo: string;
    };
    granularity?: "day" | "week" | "month";
    excludeEmptyString?: boolean;
    includeOther?: boolean;
  };
};
export type GetMcbimItemsUniqueClassesApiResponse =
  /** status 200 Successful response */ {
    instanceClasses: string[];
    typeClasses: string[];
    instanceClassCounts: {
      ifcClass: string;
      count: number;
    }[];
    typeClassCounts: {
      ifcClass: string;
      count: number;
    }[];
  };
export type GetMcbimItemsUniqueClassesApiArg = {
  projectNo: number;
  buildingStoryName: string;
};
export type GetMcbimCeilingLinesApiResponse =
  /** status 200 Successful response */ {
    [key: string]: number[][][];
  };
export type GetMcbimCeilingLinesApiArg = {
  projectNo: number;
  jobId: string;
  floorGlobalId?: string;
};
export type GetMcbimPipeSeriesApiResponse =
  /** status 200 Successful response */ {
    name: string;
    dimensions: number[];
  }[];
export type GetMcbimPipeSeriesApiArg = {
  projectNo: number;
};
export type GetMcbimFragsApiResponse = /** status 200 Successful response */ {
  projectNo: number;
  containerName: string;
  ttlMinutes: number;
  files: {
    fileName: string;
    frag: {
      blobName: string;
      url: string;
      expiresAt: string;
      sizeBytes?: number;
    };
    manifest: {
      blobName: string;
      url: string;
      expiresAt: string;
      sizeBytes?: number;
    };
  }[];
};
export type GetMcbimFragsApiArg = {
  projectNo: number;
};
export type PostMultiplacerRoomsApiResponse =
  /** status 200 Successful response */ {
    [key: string]: {
      _id: string;
      projectNo: number;
      roomNumber: string;
      roomNumbering?: {
        suggested?: string;
        run?: {
          methodKey: string;
          runBy: {
            _id?: any;
            name: string;
          };
          runAt: string;
        };
        value?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
        updatedAt?: string;
        approval?: {
          approvedBy: {
            _id?: any;
            name: string;
          };
          approvedAt: string;
        };
      };
      roomName?: string;
      airFlow?: {
        selected?: {
          supply?: {
            value: number;
            source: "excel" | "manual";
            selectedAt?: string;
            selectedBy?: {
              _id?: any;
              name: string;
            };
          };
          exhaust?: {
            value: number;
            source: "excel" | "manual";
            selectedAt?: string;
            selectedBy?: {
              _id?: any;
              name: string;
            };
          };
        };
        excel?: {
          supply?: number;
          exhaust?: number;
          comment?: string;
          sourceRef?: {
            system?: string;
            id?: string;
            fileName?: string;
            importId?: string;
          };
          importedAt?: string;
          importedBy?: {
            _id?: any;
            name: string;
          };
        };
        manual?: {
          supply?: number;
          exhaust?: number;
          comment?: string;
          updatedAt?: string;
          updatedBy?: {
            _id?: any;
            name: string;
          };
        };
        comments?: {
          _id?: any;
          message: string;
          createdBy: {
            _id?: any;
            name: string;
          };
          createdAt: string;
          editedAt?: string | null;
          deletedAt?: string | null;
        }[];
      };
      ceilingComments: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
      supplyAirFlow?: number;
      returnAirFlow?: number;
      rfpStatus?: string | null;
      rfpMalRom?: string | null;
      drStatus?: string | null;
      designDeviationStatus?: string | null;
      updatedAt?: string;
      multiplacerCeilingDevicesLocked?: {
        bool: boolean;
        lockedAt?: string;
        createdBy?: {
          _id?: any;
          name: string;
        };
      };
      extraIfcInfo?: {
        pns?: string | null;
        floor?: string | null;
        mmi?: string | null;
        ceilingMmi?: string | null;
      };
      validation?: {
        standardRoom?: {
          [key: string]: {
            summary: {
              matchRatePct: number | null;
            };
          };
        };
        specifiedArticles?: {
          summary: {
            matchRatePct: number | null;
          };
          perResponsibility?: {
            [key: string]: {
              summary: {
                matchRatePct: number | null;
              };
            };
          } | null;
        } | null;
      };
      validationDecisions?: {
        standardRoom?: {
          [key: string]: {
            current: {
              status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
              updatedByUserName: string;
              updatedAt: string;
            };
          };
        };
      };
    };
  };
export type PostMultiplacerRoomsApiArg = {
  body: {
    projectNo: number;
    roomNumbers?: string[];
    pns?: string[];
  };
};
export type GetMultiplacerSingleRoomApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: string;
        runBy: {
          _id?: any;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id?: any;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id?: any;
          name: string;
        };
        approvedAt: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id?: any;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
      };
      comments?: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id?: any;
      message: string;
      createdBy: {
        _id?: any;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id?: any;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id?: any;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
      }[];
    };
  } | null;
export type GetMultiplacerSingleRoomApiArg = {
  roomNumber: string;
  projectNo: number;
};
export type GetMultiplacerStandardRoomsApiResponse =
  /** status 200 Successful response */ string[];
export type GetMultiplacerStandardRoomsApiArg = {
  projectNo: number;
};
export type PutMultiplacerRoomLockApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: string;
        runBy: {
          _id?: any;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id?: any;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id?: any;
          name: string;
        };
        approvedAt: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id?: any;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
      };
      comments?: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id?: any;
      message: string;
      createdBy: {
        _id?: any;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id?: any;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id?: any;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
      }[];
    };
  };
export type PutMultiplacerRoomLockApiArg = {
  body: {
    roomNumber: string;
    lock: boolean;
    projectNo: number;
  };
};
export type PostMultiplacerRoomCeilingApiResponse =
  /** status 200 Successful response */ {
    matchedCount: number;
    modifiedCount: number;
    upsertedCount: number;
    upsertedIds: string[];
  };
export type PostMultiplacerRoomCeilingApiArg = {
  body: {
    projectNo: number;
    rooms: {
      roomNumber: string;
      ceilingCoordinate?: number[];
      ceilingDirection?: number[];
    }[];
  };
};
export type PostMultiplacerAirflowsImportApiResponse =
  /** status 200 Successful response */ {
    counts: {
      received: number;
      deduplicated: number;
      matched: number;
      updated: number;
      unchanged: number;
      unknown: number;
    };
    unknownRooms: string[];
  };
export type PostMultiplacerAirflowsImportApiArg = {
  body: {
    projectNo: number;
    items: {
      roomNumber: string;
      supplyAirFlow: number;
      returnAirFlow: number;
    }[];
    dryRun?: boolean;
    sourceFileName?: string;
    comment?: string;
  };
};
export type DeleteMultiplacerRoomValidationApiResponse =
  /** status 200 Successful response */ {
    deletedCount: number;
  };
export type DeleteMultiplacerRoomValidationApiArg = {
  projectNo: number;
};
export type PostMultiplacerRoomValidationDecisionStatusApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: string;
        runBy: {
          _id?: any;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id?: any;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id?: any;
          name: string;
        };
        approvedAt: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id?: any;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
      };
      comments?: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id?: any;
      message: string;
      createdBy: {
        _id?: any;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id?: any;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id?: any;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
      }[];
    };
  };
export type PostMultiplacerRoomValidationDecisionStatusApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    decisionKey: string;
    status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
    comment?: string;
  };
};
export type PostMultiplacerRoomValidationDecisionCommentApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: string;
        runBy: {
          _id?: any;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id?: any;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id?: any;
          name: string;
        };
        approvedAt: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id?: any;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
      };
      comments?: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id?: any;
      message: string;
      createdBy: {
        _id?: any;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id?: any;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id?: any;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
      }[];
    };
  };
export type PostMultiplacerRoomValidationDecisionCommentApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    decisionKey: string;
    message: string;
  };
};
export type PostMultiplacerRoomValidationDecisionCommentUpdateApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: string;
        runBy: {
          _id?: any;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id?: any;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id?: any;
          name: string;
        };
        approvedAt: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id?: any;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
      };
      comments?: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id?: any;
      message: string;
      createdBy: {
        _id?: any;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id?: any;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id?: any;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
      }[];
    };
  };
export type PostMultiplacerRoomValidationDecisionCommentUpdateApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    decisionKey: string;
    commentId: string;
    message: string;
  };
};
export type PostMultiplacerRoomValidationDecisionCommentDeleteApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: string;
        runBy: {
          _id?: any;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id?: any;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id?: any;
          name: string;
        };
        approvedAt: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id?: any;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
      };
      comments?: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id?: any;
      message: string;
      createdBy: {
        _id?: any;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id?: any;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id?: any;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
      }[];
    };
  };
export type PostMultiplacerRoomValidationDecisionCommentDeleteApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    decisionKey: string;
    commentId: string;
  };
};
export type PostMultiplacerRoomCeilingCommentApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: string;
        runBy: {
          _id?: any;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id?: any;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id?: any;
          name: string;
        };
        approvedAt: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id?: any;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
      };
      comments?: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id?: any;
      message: string;
      createdBy: {
        _id?: any;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id?: any;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id?: any;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
      }[];
    };
  };
export type PostMultiplacerRoomCeilingCommentApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    message: string;
  };
};
export type PostMultiplacerRoomCeilingCommentUpdateApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: string;
        runBy: {
          _id?: any;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id?: any;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id?: any;
          name: string;
        };
        approvedAt: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id?: any;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
      };
      comments?: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id?: any;
      message: string;
      createdBy: {
        _id?: any;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id?: any;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id?: any;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
      }[];
    };
  };
export type PostMultiplacerRoomCeilingCommentUpdateApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    commentId: string;
    message: string;
  };
};
export type PostMultiplacerRoomCeilingCommentDeleteApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: string;
        runBy: {
          _id?: any;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id?: any;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id?: any;
          name: string;
        };
        approvedAt: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id?: any;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
      };
      comments?: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id?: any;
      message: string;
      createdBy: {
        _id?: any;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id?: any;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id?: any;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
      }[];
    };
  };
export type PostMultiplacerRoomCeilingCommentDeleteApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    commentId: string;
  };
};
export type PostMultiplacerRoomSnapshotTrendByKeyApiResponse =
  /** status 200 Successful response */ {
    date: string;
    series: {
      value?: any;
      count: number;
    }[];
    total: number;
  }[];
export type PostMultiplacerRoomSnapshotTrendByKeyApiArg = {
  body: {
    projectNo: number;
    keyPath?: any;
    filter: {
      roomNumbers?: string[];
      pns?: string[];
      dateFrom: string;
      dateTo: string;
    };
    granularity?: "day" | "week" | "month";
    excludeEmptyString?: boolean;
    bucketConfig?:
      | {
          kind: "none";
        }
      | {
          kind: "ranges";
          ranges: {
            id: string;
            min: number;
            max: number;
          }[];
        };
  };
};
export type PostMultiplacerRoomsUpdateCalculatedRoomNumbersApiResponse =
  /** status 200 Successful response */ {
    counts: {
      received: number;
      matched: number;
      updated: number;
      unchanged: number;
      unknown: number;
    };
    unknownRooms: string[];
  };
export type PostMultiplacerRoomsUpdateCalculatedRoomNumbersApiArg = {
  body: {
    projectNo: number;
    methodKey: string;
    roomNumberToCalculatedRoomNumber: {
      [key: string]: string;
    };
  };
};
export type PutMultiplacerRoomsRoomNumberingManualValueApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: string;
        runBy: {
          _id?: any;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id?: any;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id?: any;
          name: string;
        };
        approvedAt: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id?: any;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
      };
      comments?: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id?: any;
      message: string;
      createdBy: {
        _id?: any;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id?: any;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id?: any;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
      }[];
    };
  };
export type PutMultiplacerRoomsRoomNumberingManualValueApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    value: string;
  };
};
export type DeleteMultiplacerRoomsRoomNumberingManualValueApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: string;
        runBy: {
          _id?: any;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id?: any;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id?: any;
          name: string;
        };
        approvedAt: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id?: any;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
      };
      comments?: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id?: any;
      message: string;
      createdBy: {
        _id?: any;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id?: any;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id?: any;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
      }[];
    };
  };
export type DeleteMultiplacerRoomsRoomNumberingManualValueApiArg = {
  projectNo: number;
  roomNumber: string;
};
export type PostMultiplacerRoomsRoomNumberingApprovalApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: string;
        runBy: {
          _id?: any;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id?: any;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id?: any;
          name: string;
        };
        approvedAt: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id?: any;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
      };
      comments?: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id?: any;
      message: string;
      createdBy: {
        _id?: any;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id?: any;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id?: any;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
      }[];
    };
  };
export type PostMultiplacerRoomsRoomNumberingApprovalApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
  };
};
export type DeleteMultiplacerRoomsRoomNumberingApprovalApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: string;
        runBy: {
          _id?: any;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id?: any;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id?: any;
          name: string;
        };
        approvedAt: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id?: any;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
      };
      comments?: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id?: any;
      message: string;
      createdBy: {
        _id?: any;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id?: any;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id?: any;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
      }[];
    };
  };
export type DeleteMultiplacerRoomsRoomNumberingApprovalApiArg = {
  projectNo: number;
  roomNumber: string;
};
export type PostMultiplacerRoomsRoomNumberingApprovalBulkApiResponse =
  /** status 200 Successful response */ {
    counts: {
      requested: number;
      matched: number;
      updated: number;
      unknown: number;
      skippedMissingValue?: number;
    };
    unknownRooms: string[];
    rooms: {
      _id: string;
      projectNo: number;
      roomNumber: string;
      roomNumbering?: {
        suggested?: string;
        run?: {
          methodKey: string;
          runBy: {
            _id?: any;
            name: string;
          };
          runAt: string;
        };
        value?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
        updatedAt?: string;
        approval?: {
          approvedBy: {
            _id?: any;
            name: string;
          };
          approvedAt: string;
        };
      };
      roomName?: string;
      airFlow?: {
        selected?: {
          supply?: {
            value: number;
            source: "excel" | "manual";
            selectedAt?: string;
            selectedBy?: {
              _id?: any;
              name: string;
            };
          };
          exhaust?: {
            value: number;
            source: "excel" | "manual";
            selectedAt?: string;
            selectedBy?: {
              _id?: any;
              name: string;
            };
          };
        };
        excel?: {
          supply?: number;
          exhaust?: number;
          comment?: string;
          sourceRef?: {
            system?: string;
            id?: string;
            fileName?: string;
            importId?: string;
          };
          importedAt?: string;
          importedBy?: {
            _id?: any;
            name: string;
          };
        };
        manual?: {
          supply?: number;
          exhaust?: number;
          comment?: string;
          updatedAt?: string;
          updatedBy?: {
            _id?: any;
            name: string;
          };
        };
        comments?: {
          _id?: any;
          message: string;
          createdBy: {
            _id?: any;
            name: string;
          };
          createdAt: string;
          editedAt?: string | null;
          deletedAt?: string | null;
        }[];
      };
      ceilingComments: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
      supplyAirFlow?: number;
      returnAirFlow?: number;
      rfpStatus?: string | null;
      rfpMalRom?: string | null;
      drStatus?: string | null;
      designDeviationStatus?: string | null;
      updatedAt?: string;
      multiplacerCeilingDevicesLocked?: {
        bool: boolean;
        lockedAt?: string;
        createdBy?: {
          _id?: any;
          name: string;
        };
      };
      validation?: {
        standardRoom?: {
          [key: string]: {
            standardRoomId: string;
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            engineVersion?: string;
            sourceFingerprint?: string;
            validatedAt: string;
            validatedBy: string;
            note?: string;
          };
        };
        specifiedArticles?: {
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          quantities?: {
            expectedQuantityTotal: number;
            observedQuantityTotal: number;
            quantityDeltaTotal: number;
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string | null;
          validatedAt: string;
          validatedBy: string;
          note?: string | null;
          perResponsibility?: {
            [key: string]: {
              summary: {
                matchRatePct: number;
                itemsTotal: number;
                itemsMatched: number;
                itemsMissing: number;
                itemsExtra: number;
                status:
                  | "OK"
                  | "WARNING"
                  | "ERROR"
                  | "invalidGeometry"
                  | "noStandardRoom";
              };
              quantities?: {
                expectedQuantityTotal: number;
                observedQuantityTotal: number;
                quantityDeltaTotal: number;
              };
              comparison: {
                compCode: string;
                label?: string | null;
                standardCount: number;
                instanceCount: number;
                delta: number;
              }[];
            };
          };
        };
      };
      validationDecisions?: {
        standardRoom?: {
          [key: string]: {
            current?: {
              status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
              comment?: string | null;
              updatedByUserId: string;
              updatedByUserName: string;
              updatedAt: string;
            } | null;
            history: {
              status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
              comment?: string | null;
              updatedByUserId: string;
              updatedByUserName: string;
              updatedAt: string;
            }[];
            comments: {
              _id?: any;
              message: string;
              createdBy: {
                _id?: any;
                name: string;
              };
              createdAt: string;
              editedAt?: string | null;
              deletedAt?: string | null;
            }[];
          };
        };
      };
      extraIfcInfo?: {
        pns?: string | null;
        floor?: string | null;
        mmi?: string | null;
        ceilingMmi?: string | null;
      };
      mlPredictedDevices?: {
        deviceCategory:
          | "CHILLER_DEVICE"
          | "DEFAULT_DEVICE"
          | "DOOR"
          | "DOWN_LIGHT_DEVICE"
          | "FIRE_SUPPRESSION_DEVICE"
          | "FURNITURE"
          | "LIGHT_DEVICE_CIRCULAR"
          | "LIGHT_DEVICE"
          | "RETURN_AIR_DEVICE"
          | "SENSOR_DEVICE"
          | "SUPPLY_AIR_DEVICE"
          | "WINDOW";
        direction: number[];
        coordinate: number[];
      }[];
      mlPredictionMetadata?: {
        importedAt: string;
        generatedAt?: string | null;
        source: string;
        blobName: string;
      };
      existsInRfp?: boolean;
      existsInMcbim?: boolean;
      specifiedArticles?: {
        compCode: string;
        quantity: number;
        name?: string;
        responsibility?: string;
        category?: string;
        flags?: {
          toBeDrawn?: boolean;
          bip?: boolean;
        };
        sourceRef?: {
          system?: string;
          id?: string;
        };
      }[];
      specifiedArticlesSync?: {
        syncedAt: string;
        source?: string;
        version?: string;
      };
      polygonSnapshot?: {
        polygon: number[][];
        polygonHash: string;
      };
      ceilingGridIntersection?: {
        x: number;
        y: number;
        direction?: {
          x: number;
          y: number;
        };
      };
      mcbimItemsSnapshot?: {
        meta: {
          builtAt: string;
          runId: string;
          sourceKey: string;
        };
        items: {
          globalId: string;
          discipline?: string | null;
          system?: string | null;
          name?: string | null;
          typeName?: string | null;
          instanceClass: string;
          mmi?: string | null;
          compCode?: string | null;
          bboxSnapshot?: {
            bbox: number[][];
            bboxHash: string;
            hashVersion: 1;
          } | null;
        }[];
      };
    }[];
  };
export type PostMultiplacerRoomsRoomNumberingApprovalBulkApiArg = {
  body: {
    projectNo: number;
    roomNumbers: string[];
  };
};
export type PostMultiplacerRoomsRoomNumberingApprovalBulkClearApiResponse =
  /** status 200 Successful response */ {
    counts: {
      requested: number;
      matched: number;
      updated: number;
      unknown: number;
      skippedMissingValue?: number;
    };
    unknownRooms: string[];
    rooms: {
      _id: string;
      projectNo: number;
      roomNumber: string;
      roomNumbering?: {
        suggested?: string;
        run?: {
          methodKey: string;
          runBy: {
            _id?: any;
            name: string;
          };
          runAt: string;
        };
        value?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
        updatedAt?: string;
        approval?: {
          approvedBy: {
            _id?: any;
            name: string;
          };
          approvedAt: string;
        };
      };
      roomName?: string;
      airFlow?: {
        selected?: {
          supply?: {
            value: number;
            source: "excel" | "manual";
            selectedAt?: string;
            selectedBy?: {
              _id?: any;
              name: string;
            };
          };
          exhaust?: {
            value: number;
            source: "excel" | "manual";
            selectedAt?: string;
            selectedBy?: {
              _id?: any;
              name: string;
            };
          };
        };
        excel?: {
          supply?: number;
          exhaust?: number;
          comment?: string;
          sourceRef?: {
            system?: string;
            id?: string;
            fileName?: string;
            importId?: string;
          };
          importedAt?: string;
          importedBy?: {
            _id?: any;
            name: string;
          };
        };
        manual?: {
          supply?: number;
          exhaust?: number;
          comment?: string;
          updatedAt?: string;
          updatedBy?: {
            _id?: any;
            name: string;
          };
        };
        comments?: {
          _id?: any;
          message: string;
          createdBy: {
            _id?: any;
            name: string;
          };
          createdAt: string;
          editedAt?: string | null;
          deletedAt?: string | null;
        }[];
      };
      ceilingComments: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
      supplyAirFlow?: number;
      returnAirFlow?: number;
      rfpStatus?: string | null;
      rfpMalRom?: string | null;
      drStatus?: string | null;
      designDeviationStatus?: string | null;
      updatedAt?: string;
      multiplacerCeilingDevicesLocked?: {
        bool: boolean;
        lockedAt?: string;
        createdBy?: {
          _id?: any;
          name: string;
        };
      };
      validation?: {
        standardRoom?: {
          [key: string]: {
            standardRoomId: string;
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            engineVersion?: string;
            sourceFingerprint?: string;
            validatedAt: string;
            validatedBy: string;
            note?: string;
          };
        };
        specifiedArticles?: {
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          quantities?: {
            expectedQuantityTotal: number;
            observedQuantityTotal: number;
            quantityDeltaTotal: number;
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string | null;
          validatedAt: string;
          validatedBy: string;
          note?: string | null;
          perResponsibility?: {
            [key: string]: {
              summary: {
                matchRatePct: number;
                itemsTotal: number;
                itemsMatched: number;
                itemsMissing: number;
                itemsExtra: number;
                status:
                  | "OK"
                  | "WARNING"
                  | "ERROR"
                  | "invalidGeometry"
                  | "noStandardRoom";
              };
              quantities?: {
                expectedQuantityTotal: number;
                observedQuantityTotal: number;
                quantityDeltaTotal: number;
              };
              comparison: {
                compCode: string;
                label?: string | null;
                standardCount: number;
                instanceCount: number;
                delta: number;
              }[];
            };
          };
        };
      };
      validationDecisions?: {
        standardRoom?: {
          [key: string]: {
            current?: {
              status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
              comment?: string | null;
              updatedByUserId: string;
              updatedByUserName: string;
              updatedAt: string;
            } | null;
            history: {
              status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
              comment?: string | null;
              updatedByUserId: string;
              updatedByUserName: string;
              updatedAt: string;
            }[];
            comments: {
              _id?: any;
              message: string;
              createdBy: {
                _id?: any;
                name: string;
              };
              createdAt: string;
              editedAt?: string | null;
              deletedAt?: string | null;
            }[];
          };
        };
      };
      extraIfcInfo?: {
        pns?: string | null;
        floor?: string | null;
        mmi?: string | null;
        ceilingMmi?: string | null;
      };
      mlPredictedDevices?: {
        deviceCategory:
          | "CHILLER_DEVICE"
          | "DEFAULT_DEVICE"
          | "DOOR"
          | "DOWN_LIGHT_DEVICE"
          | "FIRE_SUPPRESSION_DEVICE"
          | "FURNITURE"
          | "LIGHT_DEVICE_CIRCULAR"
          | "LIGHT_DEVICE"
          | "RETURN_AIR_DEVICE"
          | "SENSOR_DEVICE"
          | "SUPPLY_AIR_DEVICE"
          | "WINDOW";
        direction: number[];
        coordinate: number[];
      }[];
      mlPredictionMetadata?: {
        importedAt: string;
        generatedAt?: string | null;
        source: string;
        blobName: string;
      };
      existsInRfp?: boolean;
      existsInMcbim?: boolean;
      specifiedArticles?: {
        compCode: string;
        quantity: number;
        name?: string;
        responsibility?: string;
        category?: string;
        flags?: {
          toBeDrawn?: boolean;
          bip?: boolean;
        };
        sourceRef?: {
          system?: string;
          id?: string;
        };
      }[];
      specifiedArticlesSync?: {
        syncedAt: string;
        source?: string;
        version?: string;
      };
      polygonSnapshot?: {
        polygon: number[][];
        polygonHash: string;
      };
      ceilingGridIntersection?: {
        x: number;
        y: number;
        direction?: {
          x: number;
          y: number;
        };
      };
      mcbimItemsSnapshot?: {
        meta: {
          builtAt: string;
          runId: string;
          sourceKey: string;
        };
        items: {
          globalId: string;
          discipline?: string | null;
          system?: string | null;
          name?: string | null;
          typeName?: string | null;
          instanceClass: string;
          mmi?: string | null;
          compCode?: string | null;
          bboxSnapshot?: {
            bbox: number[][];
            bboxHash: string;
            hashVersion: 1;
          } | null;
        }[];
      };
    }[];
  };
export type PostMultiplacerRoomsRoomNumberingApprovalBulkClearApiArg = {
  body: {
    projectNo: number;
    roomNumbers: string[];
  };
};
export type PostMultiplacerDevicesApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    boundingBox?: number[][];
    compCode: string;
    coordinate: number[];
    createdAt?: string;
    description: string;
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction: number[];
    discipline:
      | "VENTILATION"
      | "ELECTRICAL"
      | "SPRINKLER"
      | "ARCHITECTURE"
      | "UNKNOWN";
    floor: string;
    grid?: any;
    pns?: string;
    productName?: string;
    projectNo: string;
    returnAirFlow?: number;
    roomName?: string;
    roomNumber: string;
    supplyAirFlow?: number;
    tileSize?: number[];
    updatedAt?: string;
    bottomEdgeHeightAboveFloorMm: number;
    bottomEdgeHeightAboveFloorM?: number;
  }[];
export type PostMultiplacerDevicesApiArg = {
  body: {
    floor?: string;
    projectNo: number;
    roomNumbers?: string[];
  };
};
export type PostMultiplacerDevicesSimilarRoomsWithIfcDesignApiResponse =
  /** status 200 Successful response */ {
    roomNumber: string;
    floor?: string;
    polygon: number[][];
    ceilingGrids?: {
      lines: number[][][];
      /** 3D point represented as [x, y, z] */
      intersectionPoint?: number[];
      /** 3D point represented as [x, y, z] */
      direction?: number[];
      tileSize?: number[];
      interiorLines?: number[][][];
      edgePolygon?: number[][];
      floorHeightMm?: number;
      floorHeightM?: number;
      worldHeightMm?: number;
      worldHeightM?: number;
    }[];
    ifcDeviceCount: number;
    similarityScore: number;
  }[];
export type PostMultiplacerDevicesSimilarRoomsWithIfcDesignApiArg = {
  body: {
    projectNo: number;
    roomName: string;
    roomNumber: string;
  };
};
export type PostMultiplacerDevicesSimilarRoomsWithDevicesApiResponse =
  /** status 200 Successful response */ {
    roomNumber: string;
    floor?: string;
    polygon: number[][];
    ceilingGrids?: {
      lines: number[][][];
      /** 3D point represented as [x, y, z] */
      intersectionPoint?: number[];
      /** 3D point represented as [x, y, z] */
      direction?: number[];
      tileSize?: number[];
      interiorLines?: number[][][];
      edgePolygon?: number[][];
      floorHeightMm?: number;
      floorHeightM?: number;
      worldHeightMm?: number;
      worldHeightM?: number;
    }[];
    locked?: boolean;
    lockedAt?: string;
    lockedBy?: {
      _id?: any;
      name: string;
    };
    similarityScore: number;
  }[];
export type PostMultiplacerDevicesSimilarRoomsWithDevicesApiArg = {
  body: {
    projectNo: number;
    locked?: boolean | null;
    roomName: string;
    roomNumber: string;
  };
};
export type PutMultiplacerDeviceUpdateApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    boundingBox?: number[][];
    compCode: string;
    coordinate: number[];
    createdAt?: string;
    description: string;
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction: number[];
    discipline:
      | "VENTILATION"
      | "ELECTRICAL"
      | "SPRINKLER"
      | "ARCHITECTURE"
      | "UNKNOWN";
    floor: string;
    grid?: any;
    pns?: string;
    productName?: string;
    projectNo: string;
    returnAirFlow?: number;
    roomName?: string;
    roomNumber: string;
    supplyAirFlow?: number;
    tileSize?: number[];
    updatedAt?: string;
    bottomEdgeHeightAboveFloorMm: number;
    bottomEdgeHeightAboveFloorM?: number;
  };
export type PutMultiplacerDeviceUpdateApiArg = {
  body: {
    device: {
      _id: string;
      boundingBox?: number[][];
      compCode: string;
      coordinate: number[];
      createdAt?: string;
      description: string;
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      discipline:
        | "VENTILATION"
        | "ELECTRICAL"
        | "SPRINKLER"
        | "ARCHITECTURE"
        | "UNKNOWN";
      floor: string;
      grid?: any;
      pns?: string;
      productName?: string;
      projectNo: string;
      returnAirFlow?: number;
      roomName?: string;
      roomNumber: string;
      supplyAirFlow?: number;
      tileSize?: number[];
      updatedAt?: string;
      bottomEdgeHeightAboveFloorMm: number;
      bottomEdgeHeightAboveFloorM?: number;
    };
  };
};
export type PostMultiplacerDeviceAddDevicesApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    boundingBox?: number[][];
    compCode: string;
    coordinate: number[];
    createdAt?: string;
    description: string;
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction: number[];
    discipline:
      | "VENTILATION"
      | "ELECTRICAL"
      | "SPRINKLER"
      | "ARCHITECTURE"
      | "UNKNOWN";
    floor: string;
    grid?: any;
    pns?: string;
    productName?: string;
    projectNo: string;
    returnAirFlow?: number;
    roomName?: string;
    roomNumber: string;
    supplyAirFlow?: number;
    tileSize?: number[];
    updatedAt?: string;
    bottomEdgeHeightAboveFloorMm: number;
    bottomEdgeHeightAboveFloorM?: number;
  }[];
export type PostMultiplacerDeviceAddDevicesApiArg = {
  body: {
    devices: {
      boundingBox?: number[][];
      compCode: string;
      coordinate: number[];
      description: string;
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      discipline:
        | "VENTILATION"
        | "ELECTRICAL"
        | "SPRINKLER"
        | "ARCHITECTURE"
        | "UNKNOWN";
      floor: string;
      grid?: any;
      pns?: string;
      productName?: string;
      projectNo: string;
      returnAirFlow?: number;
      roomName?: string;
      roomNumber: string;
      supplyAirFlow?: number;
      tileSize?: number[];
      bottomEdgeHeightAboveFloorMm: number;
      bottomEdgeHeightAboveFloorM?: number;
    }[];
  };
};
export type GetMultiplacerMediaAssetsApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    key: string;
    isProtected?: boolean | null;
    kind: "VIDEO" | "FILE";
    title: string;
    description?: string | null;
    blobPath: string;
    mimeType?: string | null;
    tags?: string[] | null;
    version?: string | null;
    visibility?: ("PUBLIC" | "AUTH" | null) | null;
    filename?: string | null;
    sizeBytes?: number | null;
    uploadedAt?: string | null;
    updatedAt?: string | null;
  }[];
export type GetMultiplacerMediaAssetsApiArg = void;
export type DeleteMultiplacerMediaAssetsByKeyApiResponse =
  /** status 200 Successful response */ {
    deletedFromBlob: boolean;
    removedFromDb: boolean;
  };
export type DeleteMultiplacerMediaAssetsByKeyApiArg = {
  key: string;
};
export type GetMultiplacerMediaAssetsMediaAssetKeyApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    key: string;
    isProtected?: boolean | null;
    kind: "VIDEO" | "FILE";
    title: string;
    description?: string | null;
    blobPath: string;
    mimeType?: string | null;
    tags?: string[] | null;
    version?: string | null;
    visibility?: ("PUBLIC" | "AUTH" | null) | null;
    filename?: string | null;
    sizeBytes?: number | null;
    uploadedAt?: string | null;
    updatedAt?: string | null;
  } | null;
export type GetMultiplacerMediaAssetsMediaAssetKeyApiArg = {
  mediaAssetKey:
    | "REVIT_DEMO"
    | "REVIT_PLUGIN_INSTALLER"
    | "FREETEXT_SEARCH"
    | "CEILING_MODULE"
    | "RFP_MODULE"
    | "EXPLORE_MODULE"
    | "COMPONENT"
    | "COLORFILTER";
};
export type PostMultiplacerDeviceDeleteInRoomsApiResponse =
  /** status 200 Successful response */ {
    deletedCount: number;
  };
export type PostMultiplacerDeviceDeleteInRoomsApiArg = {
  body: {
    projectNo: number;
    roomNumbers: string[];
  };
};
export type DeleteMultiplacerDeviceDeleteDeviceApiResponse =
  /** status 200 Successful response */ {
    acknowledged: boolean;
    deletedCount: number;
  };
export type DeleteMultiplacerDeviceDeleteDeviceApiArg = {
  deviceId: string;
};
export type GetAuthMeApiResponse = /** status 200 Successful response */ {
  _id: string;
  displayName: string;
  email?: string;
  isExternal?: boolean;
};
export type GetAuthMeApiArg = void;
export type GetAuthUsersByUserIdProfilePhotoApiResponse =
  /** status 200 Successful response */ {
    dataUrl: string | null;
  };
export type GetAuthUsersByUserIdProfilePhotoApiArg = {
  userId: string;
};
export type GetProjectSyncRunsApiResponse =
  /** status 200 Successful response */ {
    items: {
      _id?: string;
      projectNo: number;
      type: "syncPipeline";
      trigger: "manual" | "scheduled" | "queue";
      requestedBy?: string | null;
      correlationId?: string | null;
      status: "running" | "succeeded" | "failed" | "canceled" | "queued";
      createdAt: string;
      startedAt?: string;
      finishedAt?: string;
      elapsedMs?: number;
      steps: {
        roomsSync?: {
          status:
            | "pending"
            | "running"
            | "succeeded"
            | "failed"
            | "skipped"
            | "queued";
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          result?: {
            stats: {
              rfpFetched: number;
              rfpFetchFailed: boolean;
              ifcSpacesFetched: number;
              uniqueRoomNumbers: number;
              flagsResetRoomsMatched: number;
              upsertOps: number;
            };
          };
          error?: {
            origin?: "upstream" | "config" | "network" | "db" | "unknown";
            code?: string | number;
            message: string;
            stack?: string;
          };
        };
        specifiedArticlesSync?: {
          status: "running" | "succeeded" | "failed" | "pending";
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          result?: {
            fetchedRows: number;
            uniqueRoomNumbers: number;
            resetMatchedRooms: number;
            bulkOps: number;
          };
          error?: {
            origin: string;
            code?: string | null;
            message?: string | null;
            stack?: string | null;
          } | null;
        };
        enqueueEnrich?: {
          status:
            | "pending"
            | "running"
            | "succeeded"
            | "failed"
            | "skipped"
            | "queued";
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          jobTypes?: (
            | "specifiedArticles"
            | "mlPredictDevices"
            | "deriveRoomExtraIfcInfo"
            | "addIfcInfo"
            | string
          )[];
          queuedBatches?: number;
          totalRooms?: number;
          error?: {
            origin?: "upstream" | "config" | "network" | "db" | "unknown";
            code?: string | number;
            message: string;
            stack?: string;
          };
        };
        mcbimItemsSnapshot?: {
          status: "running" | "succeeded" | "failed" | "pending";
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          result?: {
            totalExpected?: number;
            totalRooms?: number;
            ok?: number;
            skipped?: number;
            failed?: number;
            lastBatchMs?: number;
            avgMsPerRoom?: number;
            lastUpdatedAt?: string;
          };
          error?: {
            origin?: "upstream" | "config" | "network" | "db" | "unknown";
            code?: string | number;
            message: string;
            stack?: string;
          };
        };
        enrich?: {
          status:
            | "pending"
            | "running"
            | "succeeded"
            | "failed"
            | "skipped"
            | "queued";
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          total?: number;
          done?: number;
          failed?: number;
          lastUpdatedAt?: string;
          error?: {
            origin?: "upstream" | "config" | "network" | "db" | "unknown";
            code?: string | number;
            message: string;
            stack?: string;
          };
        };
      };
      meta?: {
        functionName?: string;
        invocationId?: string;
        hostInstanceId?: string;
        env?: string;
        version?: string;
      };
    }[];
    nextCursor?: string;
  };
export type GetProjectSyncRunsApiArg = {
  projectNo: number;
  limit?: number;
  cursor?: string;
};
export type GetMultiplacerAssetsSasApiResponse =
  /** status 200 Successful response */ {
    url: string;
    expiresAt: string;
  };
export type GetMultiplacerAssetsSasApiArg = {
  target: "release-notes" | "project-attachments" | "media-assets";
  blobPath: string;
};
export type GetMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiResponse =
  /** status 200 Successful response */ {
    enabled: boolean;
    days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
    hour: number;
    minute: number;
    timezone: string;
    cronExpression: string;
    pageSize: number;
    maxRows: number | null;
    updatedAt?: string;
  };
export type GetMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiArg = {
  projectNo: number;
};
export type PostMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiResponse =
  /** status 200 Successful response */ {
    enabled: boolean;
    days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
    hour: number;
    minute: number;
    timezone: string;
    cronExpression: string;
    pageSize: number;
    maxRows: number | null;
    updatedAt?: string;
  };
export type PostMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiArg = {
  body: {
    projectNo: number;
    schedule: {
      enabled?: boolean;
      days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
      hour?: number;
      minute?: number;
      timezone?: string;
      pageSize?: number;
      maxRows?: number | null;
    };
  };
};
export type GetMultiplacerDrofusInterfaceRunsApiResponse =
  /** status 200 Successful response */ {
    items: {
      _id?: string;
      projectNo: number;
      source: "drofus";
      entityType: "occurrence";
      status: "queued" | "running" | "succeeded" | "failed" | "canceled";
      trigger: "manual" | "scheduled" | "retry" | "backfill";
      startedAt: string;
      finishedAt?: string | null;
      elapsedMs?: number;
      previousRunId?: string | null;
      diffBaseRunId?: string | null;
      api: {
        baseUrl?: string;
        db?: string;
        project?: string;
        endpoint: "occurrences";
        select: string;
        selectHash: string;
        filter?: string | null;
        pageSize: number;
      };
      result?: {
        pageCount: number;
        fetchedRowCount: number;
        savedSnapshotCount?: number;
        interfaceRelevantCount?: number;
        addedCount?: number;
        updatedCount?: number;
        removedCount?: number;
        changeEventCount?: number;
      };
      error?: {
        origin?:
          | "upstream"
          | "config"
          | "network"
          | "db"
          | "validation"
          | "unknown";
        code?: string | number;
        message: string;
        stack?: string;
      };
      meta?: {
        functionName?: string;
        invocationId?: string;
        hostInstanceId?: string;
        schemaVersion: string;
      };
    }[];
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
export type GetMultiplacerDrofusInterfaceRunsApiArg = {
  limit?: number;
  offset?: number;
  projectNo: number;
  status?: "queued" | "running" | "succeeded" | "failed" | "canceled";
};
export type PostMultiplacerDrofusInterfaceDeleteRunApiResponse =
  /** status 200 Successful response */ {
    ok: true;
    runId: string;
    deletedRunCount: number;
    deletedSnapshotCount: number;
  };
export type PostMultiplacerDrofusInterfaceDeleteRunApiArg = {
  body: {
    projectNo: number;
    runId: string;
  };
};
export type PostMultiplacerDrofusInterfaceOccurrencesApiResponse =
  /** status 200 Successful response */ {
    items: {
      _id?: string;
      projectNo: number;
      runId: string;
      capturedAt: string;
      entityType: "occurrence";
      occurrenceId: number;
      stableKey: string;
      normalized: {
        occurrence: {
          id: number;
          quantity?: number | null;
          existingQuantity?: number | null;
          netQuantity?: number | null;
          classificationNumber?: string | null;
          runNo?: string | null;
          name?: string | null;
          comment?: string | null;
          responsibility?: string | null;
          overriddenResponsibility?: string | null;
          priority?: string | null;
          statusText?: string | null;
          refString?: string | null;
          extendedTfmId?: string | null;
          refCompOcc?: (string | number) | null;
          specialFunctionalRole?: string | null;
          mmiIds?: number[] | null;
          programmedStatusIds?: number[] | null;
          isSubOccurrence?: boolean | null;
          subOccurrenceDepth?: number | null;
          hasIfcGuids?: boolean | null;
          ifcGuids?: (string[] | null) | (string | null);
        };
        room: {
          id?: number | null;
          functionNo?: string | null;
          architectNo?: string | null;
          fullName?: string | null;
          classification103Code?: string | null;
          classification109Code?: string | null;
        };
        article: {
          id?: number | null;
          compCode?: string | null;
          name?: string | null;
          responsibility?: string | null;
          toBeDrawn?: boolean | null;
          bip?: boolean | null;
        };
        system: {
          primarySystemId?: number | null;
          isSystemComponent?: boolean | null;
          isComponent?: boolean | null;
          hasSystems?: string | null;
          systemMembership?: string | null;
        };
        needs: {
          electrical: boolean;
          ikt: boolean;
          automation: boolean;
          vvs: boolean;
          normalPowerKw?: number | null;
          standbyPowerKw?: number | null;
          networkOutletCount?: number | null;
          sdConnection?: boolean | null;
          roomControl?: boolean | null;
          internalAutomation?: boolean | null;
          busCommunication?: boolean | null;
          vvsWater: boolean;
          vvsDrainage: boolean;
          vvsVentilation: boolean;
          vvsCooling: boolean;
          vvsHeatEmission: boolean;
          vvsTemperatureHumidity: boolean;
          medicalGas: boolean;
        };
        occurrenceData: {
          controlSystemType?: string | null;
          controlledBy?: string | null;
          globalId?: string | null;
          modelName?: string | null;
          refLocRoomServe?: string | null;
          statedVoltage?: string | null;
          statedFrequency?: string | null;
          statedPowerW?: number | null;
          statedAmpere?: number | null;
          fieldbus?: boolean | null;
          networkName?: string | null;
          macAddress?: string | null;
          ipAddress?: string | null;
        };
      };
      sourceValues?: {
        [key: string]: string | number | boolean | string[] | number[] | null;
      };
      contentHash: string;
      normalizedHash?: string;
      interfaceRelevant: boolean;
      interfaceRelevantReasons: string[];
      affectedDisciplines: (
        | "RIV"
        | "RIE"
        | "RIAut"
        | "RIKT"
        | "ARK"
        | "IARK"
        | "RKJ"
        | "RUT"
        | "HF"
        | "UNKNOWN"
      )[];
    }[];
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
export type PostMultiplacerDrofusInterfaceOccurrencesApiArg = {
  body: {
    limit?: number;
    offset?: number;
    projectNo: number;
    runId: string;
    search?: string;
    pns?: string[];
    interfaceRelevant?: boolean;
    toBeDrawn?: boolean;
    affectedDisciplines?: (
      | "RIV"
      | "RIE"
      | "RIAut"
      | "RIKT"
      | "ARK"
      | "IARK"
      | "RKJ"
      | "RUT"
      | "HF"
      | "UNKNOWN"
    )[];
    needs?: {
      electrical?: boolean;
      ikt?: boolean;
      automation?: boolean;
      vvs?: boolean;
    };
    sort?: {
      field?:
        | "occurrenceId"
        | "roomFunctionNo"
        | "roomArchitectNo"
        | "roomName"
        | "compCode"
        | "articleName"
        | "quantity"
        | "capturedAt";
      direction?: "asc" | "desc";
    };
  };
};
export type PostMultiplacerDrofusInterfaceArticlesApiResponse =
  /** status 200 Successful response */ {
    items: {
      articleId: number | null;
      compCode: string | null;
      articleName: string | null;
      articleResponsibility?: string | null;
      toBeDrawn?: boolean | null;
      bip?: boolean | null;
      occurrenceCount: number;
      uniqueRoomCount: number;
      totalQuantity: number;
      affectedDisciplines: (
        | "RIV"
        | "RIE"
        | "RIAut"
        | "RIKT"
        | "ARK"
        | "IARK"
        | "RKJ"
        | "RUT"
        | "HF"
        | "UNKNOWN"
      )[];
      interfaceRelevantCount: number;
      needs: {
        electrical: boolean;
        ikt: boolean;
        automation: boolean;
        vvs: boolean;
      };
    }[];
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
export type PostMultiplacerDrofusInterfaceArticlesApiArg = {
  body: {
    limit?: number;
    offset?: number;
    projectNo: number;
    runId: string;
    search?: string;
    pns?: string[];
    interfaceRelevant?: boolean;
    toBeDrawn?: boolean;
    affectedDisciplines?: (
      | "RIV"
      | "RIE"
      | "RIAut"
      | "RIKT"
      | "ARK"
      | "IARK"
      | "RKJ"
      | "RUT"
      | "HF"
      | "UNKNOWN"
    )[];
    needs?: {
      electrical?: boolean;
      ikt?: boolean;
      automation?: boolean;
      vvs?: boolean;
    };
    sort?: {
      field?:
        | "articleId"
        | "compCode"
        | "articleName"
        | "occurrenceCount"
        | "uniqueRoomCount"
        | "totalQuantity";
      direction?: "asc" | "desc";
    };
  };
};
export type PostTdroomUpsertApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    roomNumber: string;
    roomLongName: string;
    area: number;
    polygon: number[][];
    devices: {
      _id?: any;
      boundingBox?: number[][];
      compCode: string;
      coordinate: number[];
      createdAt?: string;
      description: string;
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction?: number[];
      discipline:
        | "VENTILATION"
        | "ELECTRICAL"
        | "SPRINKLER"
        | "ARCHITECTURE"
        | "UNKNOWN";
      floor: string;
      grid?: any;
      pns?: string;
      productName?: string;
      projectNo: string;
      returnAirFlow?: number;
      roomName?: string;
      roomNumber: string;
      supplyAirFlow?: number;
      tileSize?: number[];
      updatedAt?: string;
      bottomEdgeHeightAboveFloorMm: number;
      bottomEdgeHeightAboveFloorM?: number;
    }[];
  } | null;
export type PostTdroomUpsertApiArg = {
  body: {
    _id?: any;
    projectNo: number;
    roomNumber: string;
    roomLongName: string;
    area: number;
    polygon: number[][];
    devices: {
      _id?: any;
      boundingBox?: number[][];
      compCode: string;
      coordinate: number[];
      createdAt?: string;
      description: string;
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction?: number[];
      discipline:
        | "VENTILATION"
        | "ELECTRICAL"
        | "SPRINKLER"
        | "ARCHITECTURE"
        | "UNKNOWN";
      floor: string;
      grid?: any;
      pns?: string;
      productName?: string;
      projectNo: string;
      returnAirFlow?: number;
      roomName?: string;
      roomNumber: string;
      supplyAirFlow?: number;
      tileSize?: number[];
      updatedAt?: string;
      bottomEdgeHeightAboveFloorMm: number;
      bottomEdgeHeightAboveFloorM?: number;
    }[];
  };
};
export type GetTdroomSingleApiResponse = /** status 200 Successful response */ {
  _id?: any;
  projectNo: number;
  roomNumber: string;
  roomLongName: string;
  area: number;
  polygon: number[][];
  devices: {
    _id?: any;
    boundingBox?: number[][];
    compCode: string;
    coordinate: number[];
    createdAt?: string;
    description: string;
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction?: number[];
    discipline:
      | "VENTILATION"
      | "ELECTRICAL"
      | "SPRINKLER"
      | "ARCHITECTURE"
      | "UNKNOWN";
    floor: string;
    grid?: any;
    pns?: string;
    productName?: string;
    projectNo: string;
    returnAirFlow?: number;
    roomName?: string;
    roomNumber: string;
    supplyAirFlow?: number;
    tileSize?: number[];
    updatedAt?: string;
    bottomEdgeHeightAboveFloorMm: number;
    bottomEdgeHeightAboveFloorM?: number;
  }[];
} | null;
export type GetTdroomSingleApiArg = {
  tdroomId: string;
};
export type GetTdroomAllApiResponse = /** status 200 Successful response */ {
  _id?: any;
  roomLongName: string;
  roomNumber: string;
  projectNo: number;
}[];
export type GetTdroomAllApiArg = void;
export type PostAddProjectTdRoomsApiResponse =
  /** status 200 Successful response */ {
    nrOfRoomsAdded: number;
  };
export type PostAddProjectTdRoomsApiArg = {
  body: {
    projectNo: number;
  };
};
export type GetMultiplacerDevicetypesApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    projectNo: number;
    instanceClass:
      | "IfcAirTerminal"
      | "IfcLightFixture"
      | "IfcFireSuppressionTerminal"
      | "IfcSensor"
      | "IfcChiller";
    compCode: string | null;
    typeName: string;
    boundingBox: number[][];
    firstDocument: {
      _id?: any;
      globalId: string;
      buildingStory: {
        elevation?: number;
        expressId?: number;
        globalId: string;
        name: string;
      } | null;
      instanceClass: string;
      expressId: number;
      predefinedType?: (string | number) | null;
      geometry?: {
        polygon2d?: number[][];
        bbox2d?: number[][];
        centerPoint2d?: number[];
        Obb3DWorldMmList?: {
          centerMm: {
            x: number;
            y: number;
            z: number;
          };
          centerM?: {
            x: number;
            y: number;
            z: number;
          };
          axisA: {
            x: number;
            y: number;
            z: number;
          };
          axisB: {
            x: number;
            y: number;
            z: number;
          };
          axisC: {
            x: number;
            y: number;
            z: number;
          };
          extentAMm: number;
          extentBMm: number;
          extentCMm: number;
          extentAM?: number;
          extentBM?: number;
          extentCM?: number;
        }[];
        zWorldMm?: {
          bottom: number;
          middle: number;
          top: number;
        };
        zWorldM?: {
          bottom: number;
          middle: number;
          top: number;
        };
        heightMm?: number;
        heightM?: number;
        floorZWorldMm?: number;
        floorZWorldM?: number;
        floorSource?: "buildingStorey" | "unknown";
        zRelMm?: {
          bottom: number;
          middle: number;
          top: number;
        };
        zRelM?: {
          bottom: number;
          middle: number;
          top: number;
        };
      };
      geometryVersion?: number;
      fileAttr1?: string;
      fileAttr2?: string;
      fileAttr3?: string;
      fileAttr4?: string;
      fileFolderId?: string;
      fileIfcSchema: string;
      fileIsLatest: boolean;
      fileLastModifiedBy: string;
      fileName: string;
      filePath: string;
      fileStorageId: string;
      fileUploadedAt: string;
      includedMaterials?: {
        [key: string]: boolean;
      };
      insertedAt: string;
      longName?: string;
      materials?: {
        [key: string]: number;
      }[];
      name: string;
      description: string;
      building?: string;
      job: {
        jobId?: any;
        createdAt: string;
      };
      bbox?: number[][];
      polygon?: number[][];
      centerPoint?: number[];
      psets: {
        [key: string]: {
          [key: string]: (string | number) | boolean;
        };
      };
      type: {
        globalId: string;
        name: string;
        typeClass: string;
        predefinedType?: (string | number) | null;
      } | null;
      ceilingGrids?: {
        lines: number[][][];
        /** 3D point represented as [x, y, z] */
        intersectionPoint?: number[];
        /** 3D point represented as [x, y, z] */
        direction?: number[];
        tileSize?: number[];
        interiorLines?: number[][][];
        edgePolygon?: number[][];
        floorHeightMm?: number;
        floorHeightM?: number;
        worldHeightMm?: number;
        worldHeightM?: number;
      }[];
      error2d?: {
        message: string;
        stack: string;
      };
      geometryExtractedFromTypeGlobalId?: string;
      elementMaterials?: {
        name: string;
        thickness: number;
        calculatedVolume?: number;
      }[];
      primarySystem?: {
        globalId: string;
        name: string;
        typeClass: string;
        predefinedType?: (string | number) | null;
      } | null;
      systems?: {
        globalId: string;
        name: string;
        typeClass: string;
        predefinedType?: (string | number) | null;
      }[];
    };
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
  }[];
export type GetMultiplacerDevicetypesApiArg = {
  projectNo: number;
};
export type PostMultiplacerDevicetypesAggregateApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    projectNo: number;
    instanceClass:
      | "IfcAirTerminal"
      | "IfcLightFixture"
      | "IfcFireSuppressionTerminal"
      | "IfcSensor"
      | "IfcChiller";
    compCode: string | null;
    typeName: string;
    boundingBox: number[][];
    firstDocument: {
      _id?: any;
      globalId: string;
      buildingStory: {
        elevation?: number;
        expressId?: number;
        globalId: string;
        name: string;
      } | null;
      instanceClass: string;
      expressId: number;
      predefinedType?: (string | number) | null;
      geometry?: {
        polygon2d?: number[][];
        bbox2d?: number[][];
        centerPoint2d?: number[];
        Obb3DWorldMmList?: {
          centerMm: {
            x: number;
            y: number;
            z: number;
          };
          centerM?: {
            x: number;
            y: number;
            z: number;
          };
          axisA: {
            x: number;
            y: number;
            z: number;
          };
          axisB: {
            x: number;
            y: number;
            z: number;
          };
          axisC: {
            x: number;
            y: number;
            z: number;
          };
          extentAMm: number;
          extentBMm: number;
          extentCMm: number;
          extentAM?: number;
          extentBM?: number;
          extentCM?: number;
        }[];
        zWorldMm?: {
          bottom: number;
          middle: number;
          top: number;
        };
        zWorldM?: {
          bottom: number;
          middle: number;
          top: number;
        };
        heightMm?: number;
        heightM?: number;
        floorZWorldMm?: number;
        floorZWorldM?: number;
        floorSource?: "buildingStorey" | "unknown";
        zRelMm?: {
          bottom: number;
          middle: number;
          top: number;
        };
        zRelM?: {
          bottom: number;
          middle: number;
          top: number;
        };
      };
      geometryVersion?: number;
      fileAttr1?: string;
      fileAttr2?: string;
      fileAttr3?: string;
      fileAttr4?: string;
      fileFolderId?: string;
      fileIfcSchema: string;
      fileIsLatest: boolean;
      fileLastModifiedBy: string;
      fileName: string;
      filePath: string;
      fileStorageId: string;
      fileUploadedAt: string;
      includedMaterials?: {
        [key: string]: boolean;
      };
      insertedAt: string;
      longName?: string;
      materials?: {
        [key: string]: number;
      }[];
      name: string;
      description: string;
      building?: string;
      job: {
        jobId?: any;
        createdAt: string;
      };
      bbox?: number[][];
      polygon?: number[][];
      centerPoint?: number[];
      psets: {
        [key: string]: {
          [key: string]: (string | number) | boolean;
        };
      };
      type: {
        globalId: string;
        name: string;
        typeClass: string;
        predefinedType?: (string | number) | null;
      } | null;
      ceilingGrids?: {
        lines: number[][][];
        /** 3D point represented as [x, y, z] */
        intersectionPoint?: number[];
        /** 3D point represented as [x, y, z] */
        direction?: number[];
        tileSize?: number[];
        interiorLines?: number[][][];
        edgePolygon?: number[][];
        floorHeightMm?: number;
        floorHeightM?: number;
        worldHeightMm?: number;
        worldHeightM?: number;
      }[];
      error2d?: {
        message: string;
        stack: string;
      };
      geometryExtractedFromTypeGlobalId?: string;
      elementMaterials?: {
        name: string;
        thickness: number;
        calculatedVolume?: number;
      }[];
      primarySystem?: {
        globalId: string;
        name: string;
        typeClass: string;
        predefinedType?: (string | number) | null;
      } | null;
      systems?: {
        globalId: string;
        name: string;
        typeClass: string;
        predefinedType?: (string | number) | null;
      }[];
    };
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
  }[];
export type PostMultiplacerDevicetypesAggregateApiArg = {
  body: {
    projectNo: number;
  };
};
export type GetMultiplacerDevicetypesStatsApiResponse =
  /** status 200 Successful response */ {
    projectNo: number;
    total: number;
    categories: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      count: number;
    }[];
  };
export type GetMultiplacerDevicetypesStatsApiArg = {
  projectNo: number;
};
export type PostMlPredictCeilingDevicesApiResponse =
  /** status 200 Successful response */ {
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction: number[];
    coordinate: number[];
  }[];
export type PostMlPredictCeilingDevicesApiArg = {
  body: {
    roomNr: string;
    projectNo: number;
    ceilingGridIntersection: {
      x: number;
      y: number;
      direction: {
        x: number;
        y: number;
      };
    };
  };
};
export type GetMlPingApiResponse = /** status 200 Successful response */ {
  message: string;
};
export type GetMlPingApiArg = void;
export type PostMultiplacerProjectAddProjectApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    title: string;
    compCodePath: string;
    cadCompCodePath?: string;
    pnsPath?: string;
    areaPath?: string;
    mmiPath?: string;
    disciplineFileAttr?: "fileAttr1" | "fileAttr2" | "fileAttr3" | "fileAttr4";
    enrich?: {
      status: "idle" | "running" | "done";
      total: number;
      done: number;
      failed?: number;
      startedAt?: string | null;
      finishedAt?: string | null;
    };
    createdAt?: string;
    updatedAt?: string;
    ventilation?: {
      compCodeDirectionRules: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
    drofusInterface?: {
      occurrencesSyncSchedule?: {
        enabled: boolean;
        days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
        hour: number;
        minute: number;
        timezone: string;
        cronExpression: string;
        pageSize: number;
        maxRows: number | null;
        updatedAt?: string;
      };
    };
    drofus?: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      hasApiKey: boolean;
      last4?: string;
      verifiedAt?: string;
      updatedAt?: string;
    };
    members: {
      userId?: any;
      displayName: string;
      role: "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
      permissions?: {
        buildingIds: string[];
        modules: {
          module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
          access: "READ" | "WRITE";
        }[];
        updatedAt?: string;
      };
      addedAt?: string;
      addedBy?: any;
    }[];
    invites: {
      _id?: any;
      email: string;
      permissions: {
        buildingIds: string[];
        modules: {
          module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
          access: "READ" | "WRITE";
        }[];
        updatedAt?: string;
      };
      invitedBy?: any;
      createdAt: string;
      expiresAt?: string;
      acceptedAt?: string;
      acceptedBy?: any;
      status: "PENDING" | "ACCEPTED" | "REVOKED";
    }[];
  };
export type PostMultiplacerProjectAddProjectApiArg = {
  body: {
    project: {
      projectNo: number;
      title: string;
      compCodePath: string;
      cadCompCodePath?: string;
      pnsPath?: string;
      areaPath?: string;
      mmiPath?: string;
      disciplineFileAttr?:
        | "fileAttr1"
        | "fileAttr2"
        | "fileAttr3"
        | "fileAttr4";
      enrich?: {
        status: "idle" | "running" | "done";
        total: number;
        done: number;
        failed?: number;
        startedAt?: string | null;
        finishedAt?: string | null;
      };
      ventilation?: {
        compCodeDirectionRules?: {
          prefix: string;
          direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
          description?: string;
        }[];
        updatedAt?: string;
      };
      drofusInterface?: {
        occurrencesSyncSchedule?: {
          enabled?: boolean;
          days?: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
          hour?: number;
          minute?: number;
          timezone?: string;
          cronExpression?: string;
          pageSize?: number;
          maxRows?: number | null;
          updatedAt?: string;
        };
      };
      members?: {
        userId?: any;
        displayName?: string;
        role?: "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
        permissions?: {
          buildingIds?: string[];
          modules?: {
            module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
            access: "READ" | "WRITE";
          }[];
          updatedAt?: string;
        };
        addedAt?: string;
        addedBy?: any;
      }[];
      invites?: {
        _id?: any;
        email: string;
        permissions?: {
          buildingIds?: string[];
          modules?: {
            module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
            access: "READ" | "WRITE";
          }[];
          updatedAt?: string;
        };
        invitedBy?: any;
        createdAt: string;
        expiresAt?: string;
        acceptedAt?: string;
        acceptedBy?: any;
        status?: "PENDING" | "ACCEPTED" | "REVOKED";
      }[];
    };
  };
};
export type GetMultiplacerProjectsApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    title: string;
    compCodePath: string;
    cadCompCodePath?: string;
    pnsPath?: string;
    areaPath?: string;
    mmiPath?: string;
    disciplineFileAttr?: "fileAttr1" | "fileAttr2" | "fileAttr3" | "fileAttr4";
    enrich?: {
      status: "idle" | "running" | "done";
      total: number;
      done: number;
      failed?: number;
      startedAt?: string | null;
      finishedAt?: string | null;
    };
    createdAt?: string;
    updatedAt?: string;
    ventilation?: {
      compCodeDirectionRules: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
    drofusInterface?: {
      occurrencesSyncSchedule?: {
        enabled: boolean;
        days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
        hour: number;
        minute: number;
        timezone: string;
        cronExpression: string;
        pageSize: number;
        maxRows: number | null;
        updatedAt?: string;
      };
    };
    drofus?: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      hasApiKey: boolean;
      last4?: string;
      verifiedAt?: string;
      updatedAt?: string;
    };
    members: {
      userId?: any;
      displayName: string;
      role: "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
      permissions?: {
        buildingIds: string[];
        modules: {
          module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
          access: "READ" | "WRITE";
        }[];
        updatedAt?: string;
      };
      addedAt?: string;
      addedBy?: any;
    }[];
    invites: {
      _id?: any;
      email: string;
      permissions: {
        buildingIds: string[];
        modules: {
          module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
          access: "READ" | "WRITE";
        }[];
        updatedAt?: string;
      };
      invitedBy?: any;
      createdAt: string;
      expiresAt?: string;
      acceptedAt?: string;
      acceptedBy?: any;
      status: "PENDING" | "ACCEPTED" | "REVOKED";
    }[];
  }[];
export type GetMultiplacerProjectsApiArg = void;
export type PostProjectDrofusUpdateSettingsApiResponse =
  /** status 200 Successful response */ {
    drofusBaseUrl: string;
    drofusDb: string;
    drofusProject: string;
    hasApiKey: boolean;
    last4?: string;
    verifiedAt?: string;
    updatedAt?: string;
  };
export type PostProjectDrofusUpdateSettingsApiArg = {
  body: {
    projectNo: number;
    settings: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      apiKey?: string;
    };
  };
};
export type GetMultiplacerProjectsSingleProjectApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    title: string;
    compCodePath: string;
    cadCompCodePath?: string;
    pnsPath?: string;
    areaPath?: string;
    mmiPath?: string;
    disciplineFileAttr?: "fileAttr1" | "fileAttr2" | "fileAttr3" | "fileAttr4";
    enrich?: {
      status: "idle" | "running" | "done";
      total: number;
      done: number;
      failed?: number;
      startedAt?: string | null;
      finishedAt?: string | null;
    };
    createdAt?: string;
    updatedAt?: string;
    ventilation?: {
      compCodeDirectionRules: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
    drofusInterface?: {
      occurrencesSyncSchedule?: {
        enabled: boolean;
        days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
        hour: number;
        minute: number;
        timezone: string;
        cronExpression: string;
        pageSize: number;
        maxRows: number | null;
        updatedAt?: string;
      };
    };
    drofus?: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      hasApiKey: boolean;
      last4?: string;
      verifiedAt?: string;
      updatedAt?: string;
    };
    members: {
      userId?: any;
      displayName: string;
      role: "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
      permissions?: {
        buildingIds: string[];
        modules: {
          module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
          access: "READ" | "WRITE";
        }[];
        updatedAt?: string;
      };
      addedAt?: string;
      addedBy?: any;
    }[];
    invites: {
      _id?: any;
      email: string;
      permissions: {
        buildingIds: string[];
        modules: {
          module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
          access: "READ" | "WRITE";
        }[];
        updatedAt?: string;
      };
      invitedBy?: any;
      createdAt: string;
      expiresAt?: string;
      acceptedAt?: string;
      acceptedBy?: any;
      status: "PENDING" | "ACCEPTED" | "REVOKED";
    }[];
  };
export type GetMultiplacerProjectsSingleProjectApiArg = {
  projectNo: number;
};
export type PostMultiplacerProjectEditProjectApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    title: string;
    compCodePath: string;
    cadCompCodePath?: string;
    pnsPath?: string;
    areaPath?: string;
    mmiPath?: string;
    disciplineFileAttr?: "fileAttr1" | "fileAttr2" | "fileAttr3" | "fileAttr4";
    enrich?: {
      status: "idle" | "running" | "done";
      total: number;
      done: number;
      failed?: number;
      startedAt?: string | null;
      finishedAt?: string | null;
    };
    createdAt?: string;
    updatedAt?: string;
    ventilation?: {
      compCodeDirectionRules: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
    drofusInterface?: {
      occurrencesSyncSchedule?: {
        enabled: boolean;
        days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
        hour: number;
        minute: number;
        timezone: string;
        cronExpression: string;
        pageSize: number;
        maxRows: number | null;
        updatedAt?: string;
      };
    };
    drofus?: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      hasApiKey: boolean;
      last4?: string;
      verifiedAt?: string;
      updatedAt?: string;
    };
    members: {
      userId?: any;
      displayName: string;
      role: "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
      permissions?: {
        buildingIds: string[];
        modules: {
          module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
          access: "READ" | "WRITE";
        }[];
        updatedAt?: string;
      };
      addedAt?: string;
      addedBy?: any;
    }[];
    invites: {
      _id?: any;
      email: string;
      permissions: {
        buildingIds: string[];
        modules: {
          module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
          access: "READ" | "WRITE";
        }[];
        updatedAt?: string;
      };
      invitedBy?: any;
      createdAt: string;
      expiresAt?: string;
      acceptedAt?: string;
      acceptedBy?: any;
      status: "PENDING" | "ACCEPTED" | "REVOKED";
    }[];
  };
export type PostMultiplacerProjectEditProjectApiArg = {
  body: {
    project: {
      projectNo: number;
      title: string;
      compCodePath: string;
      cadCompCodePath?: string;
      pnsPath?: string;
      areaPath?: string;
      mmiPath?: string;
      disciplineFileAttr?:
        | "fileAttr1"
        | "fileAttr2"
        | "fileAttr3"
        | "fileAttr4";
    };
  };
};
export type PostProjectVentilationUpdateSettingsApiResponse =
  /** status 200 Successful response */ {
    compCodeDirectionRules: {
      prefix: string;
      direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
      description?: string;
    }[];
    updatedAt?: string;
  };
export type PostProjectVentilationUpdateSettingsApiArg = {
  body: {
    projectNo: number;
    ventilation: {
      compCodeDirectionRules?: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
  };
};
export type PostMultiplacerProjectsAddMemberApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    title: string;
    compCodePath: string;
    cadCompCodePath?: string;
    pnsPath?: string;
    areaPath?: string;
    mmiPath?: string;
    disciplineFileAttr?: "fileAttr1" | "fileAttr2" | "fileAttr3" | "fileAttr4";
    enrich?: {
      status: "idle" | "running" | "done";
      total: number;
      done: number;
      failed?: number;
      startedAt?: string | null;
      finishedAt?: string | null;
    };
    createdAt?: string;
    updatedAt?: string;
    ventilation?: {
      compCodeDirectionRules: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
    drofusInterface?: {
      occurrencesSyncSchedule?: {
        enabled: boolean;
        days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
        hour: number;
        minute: number;
        timezone: string;
        cronExpression: string;
        pageSize: number;
        maxRows: number | null;
        updatedAt?: string;
      };
    };
    drofus?: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      hasApiKey: boolean;
      last4?: string;
      verifiedAt?: string;
      updatedAt?: string;
    };
    members: {
      userId?: any;
      displayName: string;
      role: "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
      permissions?: {
        buildingIds: string[];
        modules: {
          module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
          access: "READ" | "WRITE";
        }[];
        updatedAt?: string;
      };
      addedAt?: string;
      addedBy?: any;
    }[];
    invites: {
      _id?: any;
      email: string;
      permissions: {
        buildingIds: string[];
        modules: {
          module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
          access: "READ" | "WRITE";
        }[];
        updatedAt?: string;
      };
      invitedBy?: any;
      createdAt: string;
      expiresAt?: string;
      acceptedAt?: string;
      acceptedBy?: any;
      status: "PENDING" | "ACCEPTED" | "REVOKED";
    }[];
  };
export type PostMultiplacerProjectsAddMemberApiArg = {
  body: {
    projectNo: number;
    userId: string;
    role?: "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
    permissions?: {
      buildingIds?: string[];
      modules?: {
        module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
        access: "READ" | "WRITE";
      }[];
      updatedAt?: string;
    };
  };
};
export type PostMultiplacerProjectsInviteByEmailApiResponse =
  /** status 200 Successful response */ {
    ok: true;
    inviteEmail: string;
  };
export type PostMultiplacerProjectsInviteByEmailApiArg = {
  body: {
    projectNo: number;
    email: string;
    permissions?: {
      buildingIds?: string[];
      modules?: {
        module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
        access: "READ" | "WRITE";
      }[];
      updatedAt?: string;
    };
  };
};
export type PingApiResponse = /** status 200 Successful response */ {
  ping: string;
};
export type PingApiArg = void;
export type GetFunctionsPingApiResponse =
  /** status 200 Successful response */ any;
export type GetFunctionsPingApiArg = void;
export type PostMultiplacerEnrichRoomApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: string;
        runBy: {
          _id?: any;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id?: any;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id?: any;
          name: string;
        };
        approvedAt: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id?: any;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id?: any;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id?: any;
          name: string;
        };
      };
      comments?: {
        _id?: any;
        message: string;
        createdBy: {
          _id?: any;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id?: any;
      message: string;
      createdBy: {
        _id?: any;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id?: any;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id?: any;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
      }[];
    };
  } | null;
export type PostMultiplacerEnrichRoomApiArg = {
  body: {
    projectNo: number;
    roomNr: string;
    jobTypes: (
      | "specifiedArticles"
      | "mlPredictDevices"
      | "deriveRoomExtraIfcInfo"
      | "addIfcInfo"
      | string
    )[];
    dryRun?: boolean;
  };
};
export type PostMultiplacerSyncStartApiResponse =
  /** status 200 Successful response */ {
    queuedBatches: number;
    totalRooms: number;
  };
export type PostMultiplacerSyncStartApiArg = {
  body: {
    projectNo: number;
    jobTypes: (
      | "specifiedArticles"
      | "mlPredictDevices"
      | "deriveRoomExtraIfcInfo"
      | "addIfcInfo"
      | string
    )[];
  };
};
export type PostProjectDrofusVerifyConnectionApiResponse =
  /** status 200 Successful response */
    | {
        ok: true;
        usedStoredKey: boolean;
        last4?: string;
        elapsedMs: number;
      }
    | {
        ok: false;
        usedStoredKey: boolean;
        last4?: string;
        elapsedMs?: number;
        error: {
          origin: "upstream" | "config" | "network" | "unknown";
          httpStatus?: number;
          code?: string;
          message: string;
        };
      };
export type PostProjectDrofusVerifyConnectionApiArg = {
  body: {
    projectNo: number;
  };
};
export type PostMultiplacerDrofusInterfaceOccurrencesSyncApiResponse =
  /** status 200 Successful response */ {
    ok: true;
    queued: true;
    runId: string;
    previousRunId: string | null;
    projectNo: number;
    pageSize: number;
    maxRows: number | null;
    dryRun: boolean;
  };
export type PostMultiplacerDrofusInterfaceOccurrencesSyncApiArg = {
  body: {
    projectNo: number;
    top?: number;
    maxRows?: number;
    dryRun?: boolean;
  };
};
export type PostSharedZodPingApiResponse =
  /** status 200 Successful response */ {
    ok: true;
    parsed: {
      message: string;
      count?: number;
    };
  };
export type PostSharedZodPingApiArg = {
  body: {
    message: string;
    count?: number;
  };
};
export type GetSharedStaticDeviceTypeSettingsApiResponse =
  /** status 200 Successful response */ {
    [key: string]: {
      color: string;
      showDirectionInViewer: boolean;
      label: string;
      description?: string;
    };
  };
export type GetSharedStaticDeviceTypeSettingsApiArg = void;
export type PostMultiplacerReleaseNotesDeployNotesApiResponse =
  /** status 200 Successful response */ {
    id: string;
  };
export type PostMultiplacerReleaseNotesDeployNotesApiArg = {
  body: {
    mergedAt: string;
    gitSha?: string;
    pr?: {
      id?: number;
      title?: string;
    };
    internalNote?: string;
    changeItems?: {
      _id?: any;
      userFacing?: boolean;
      title: string;
      type: "added" | "changed" | "fixed";
      module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
      area: string;
      impact?: "low" | "medium" | "high";
      text: string;
      media?: {
        kind: "image" | "video";
        blobPath: string;
        posterBlobPath?: string;
        contentType?: string;
        caption?: string;
        width?: number;
        height?: number;
        durationSec?: number;
      }[];
    }[];
  };
};
export type GetMultiplacerReleaseNotesPublishedApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    version: string;
    summary?: string | null;
    releaseDate: string;
    items: {
      type: "added" | "changed" | "fixed";
      area: string;
      title?: string | null;
      module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
      impact?: "low" | "medium" | "high";
      text: string;
      media?: {
        kind: "image" | "video";
        blobPath: string;
        posterBlobPath?: string;
        contentType?: string;
        caption?: string;
        width?: number;
        height?: number;
        durationSec?: number;
      }[];
    }[];
    includedDeployNoteIds: string[];
    isPublished: boolean;
  }[];
export type GetMultiplacerReleaseNotesPublishedApiArg = void;
export type GetMultiplacerReleaseNotesDeployNotesUnpublishedApiResponse =
  /** status 200 Successful response */ {
    items: {
      _id?: any;
      mergedAt: string;
      gitSha?: string;
      pr?: {
        id?: number;
        title?: string;
      };
      internalNote?: string;
      changeItems: {
        _id?: any;
        userFacing: boolean;
        title: string;
        type: "added" | "changed" | "fixed";
        module: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
        area: string;
        impact?: "low" | "medium" | "high";
        text: string;
        media?: {
          kind: "image" | "video";
          blobPath: string;
          posterBlobPath?: string;
          contentType?: string;
          caption?: string;
          width?: number;
          height?: number;
          durationSec?: number;
        }[];
      }[];
      publishedInReleaseId?: string | null;
    }[];
    nextCursor?: string;
  };
export type GetMultiplacerReleaseNotesDeployNotesUnpublishedApiArg = {
  limit?: number;
  cursor?: string;
  module?: "CEILING" | "RFP" | "EXPLORE" | "ROOM_NUMBERING";
};
export type PostMultiplacerReleaseNotesPublishApiResponse =
  /** status 200 Successful response */ {
    releaseId: string;
  };
export type PostMultiplacerReleaseNotesPublishApiArg = {
  body: {
    version: string;
    title?: string | null;
    summary?: string | null;
    deployNoteIds: string[];
  };
};
export type DeleteMultiplacerReleaseNotesDeployNotesByDeployNoteIdChangeItemsAndChangeItemIdMediaApiResponse =
  /** status 200 Successful response */ {
    deletedFromBlob: boolean;
    removedFromDb: boolean;
  };
export type DeleteMultiplacerReleaseNotesDeployNotesByDeployNoteIdChangeItemsAndChangeItemIdMediaApiArg =
  {
    deployNoteId: string;
    changeItemId: string;
    blobPath: string;
  };
export type GetMultiplacerReleaseNotesStatusApiResponse =
  /** status 200 Successful response */ {
    latestReleaseId: string | null;
    lastSeenReleaseId: string | null;
    hasUnread: boolean;
  };
export type GetMultiplacerReleaseNotesStatusApiArg = void;
export type PostMultiplacerReleaseNotesMarkSeenApiResponse =
  /** status 200 Successful response */ {
    ok: true;
  };
export type PostMultiplacerReleaseNotesMarkSeenApiArg = {
  body: {
    releaseId: string;
  };
};
export type GetRoutingGraphListApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    systemCode: string;
    systemName?: string;
    floorName: string;
    roomNumber?: string;
    nodes: {
      id: string;
      posM: number[];
      kind: "JUNCTION" | "DEVICE_PORT";
      deviceRef?: {
        deviceId: string;
        compCodeSnapshot?: string;
        port?: "IN" | "OUT";
      };
      rooms?: string[];
      perimeter?: boolean;
    }[];
    edges: {
      id: string;
      from: string;
      to: string;
      compCode: string;
      profile: "CIRCULAR" | "RECTANGULAR";
      size:
        | {
            diameterM: number;
          }
        | {
            widthM: number;
            heightM: number;
          };
    }[];
  }[];
export type GetRoutingGraphListApiArg = {
  projectNo: number;
  floorName: string;
};
export type PostRoutingGraphSaveApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    systemCode: string;
    systemName?: string;
    floorName: string;
    roomNumber?: string;
    nodes: {
      id: string;
      posM: number[];
      kind: "JUNCTION" | "DEVICE_PORT";
      deviceRef?: {
        deviceId: string;
        compCodeSnapshot?: string;
        port?: "IN" | "OUT";
      };
      rooms?: string[];
      perimeter?: boolean;
    }[];
    edges: {
      id: string;
      from: string;
      to: string;
      compCode: string;
      profile: "CIRCULAR" | "RECTANGULAR";
      size:
        | {
            diameterM: number;
          }
        | {
            widthM: number;
            heightM: number;
          };
    }[];
  };
export type PostRoutingGraphSaveApiArg = {
  body: {
    _id?: any;
    projectNo: number;
    systemCode: string;
    systemName?: string;
    floorName: string;
    roomNumber?: string;
    nodes: {
      id: string;
      posM: number[];
      kind?: "JUNCTION" | "DEVICE_PORT";
      deviceRef?: {
        deviceId: string;
        compCodeSnapshot?: string;
        port?: "IN" | "OUT";
      };
      rooms?: string[];
      perimeter?: boolean;
    }[];
    edges: {
      id: string;
      from: string;
      to: string;
      compCode: string;
      profile: "CIRCULAR" | "RECTANGULAR";
      size:
        | {
            diameterM: number;
          }
        | {
            widthM: number;
            heightM: number;
          };
    }[];
  };
};
export type DeleteRoutingGraphDeleteApiResponse =
  /** status 200 Successful response */ {
    acknowledged: boolean;
    deletedCount: number;
  };
export type DeleteRoutingGraphDeleteApiArg = {
  graphId: string;
};
export type GetMcappsProjectPnsApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    parentId: string | null;
    props: {
      pnsId: string;
      title: string;
    };
  }[];
export type GetMcappsProjectPnsApiArg = {
  projectNo: number;
};
export type Error = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type Error2 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type Error3 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type Error4 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type Error5 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export const {
  useGetMcbimSpacesQuery,
  useGetMcbimSpacesInProjectQuery,
  useGetMcbimItemQuery,
  useGetMcbimItemsInSpaceQuery,
  useGetMcbimFileFloorVersionsQuery,
  useGetMcbimSingleMcbimSpaceQuery,
  usePostMcbimItemsQuery,
  useGetMcbimBuildingStoriesQuery,
  useGetMcbimDisciplinesQuery,
  usePostMcbimTrendByKeyQuery,
  useGetMcbimItemsUniqueClassesQuery,
  useGetMcbimCeilingLinesQuery,
  useGetMcbimPipeSeriesQuery,
  useGetMcbimFragsQuery,
  usePostMultiplacerRoomsQuery,
  useGetMultiplacerSingleRoomQuery,
  useGetMultiplacerStandardRoomsQuery,
  usePutMultiplacerRoomLockMutation,
  usePostMultiplacerRoomCeilingMutation,
  usePostMultiplacerAirflowsImportMutation,
  useDeleteMultiplacerRoomValidationMutation,
  usePostMultiplacerRoomValidationDecisionStatusMutation,
  usePostMultiplacerRoomValidationDecisionCommentMutation,
  usePostMultiplacerRoomValidationDecisionCommentUpdateMutation,
  usePostMultiplacerRoomValidationDecisionCommentDeleteMutation,
  usePostMultiplacerRoomCeilingCommentMutation,
  usePostMultiplacerRoomCeilingCommentUpdateMutation,
  usePostMultiplacerRoomCeilingCommentDeleteMutation,
  usePostMultiplacerRoomSnapshotTrendByKeyQuery,
  usePostMultiplacerRoomsUpdateCalculatedRoomNumbersMutation,
  usePutMultiplacerRoomsRoomNumberingManualValueMutation,
  useDeleteMultiplacerRoomsRoomNumberingManualValueMutation,
  usePostMultiplacerRoomsRoomNumberingApprovalMutation,
  useDeleteMultiplacerRoomsRoomNumberingApprovalMutation,
  usePostMultiplacerRoomsRoomNumberingApprovalBulkMutation,
  usePostMultiplacerRoomsRoomNumberingApprovalBulkClearMutation,
  usePostMultiplacerDevicesQuery,
  usePostMultiplacerDevicesSimilarRoomsWithIfcDesignQuery,
  usePostMultiplacerDevicesSimilarRoomsWithDevicesQuery,
  usePutMultiplacerDeviceUpdateMutation,
  usePostMultiplacerDeviceAddDevicesMutation,
  useGetMultiplacerMediaAssetsQuery,
  useDeleteMultiplacerMediaAssetsByKeyMutation,
  useGetMultiplacerMediaAssetsMediaAssetKeyQuery,
  usePostMultiplacerDeviceDeleteInRoomsMutation,
  useDeleteMultiplacerDeviceDeleteDeviceMutation,
  useGetAuthMeQuery,
  useGetAuthUsersByUserIdProfilePhotoQuery,
  useGetProjectSyncRunsQuery,
  useGetMultiplacerAssetsSasQuery,
  useGetMultiplacerDrofusInterfaceOccurrencesSyncScheduleQuery,
  usePostMultiplacerDrofusInterfaceOccurrencesSyncScheduleMutation,
  useGetMultiplacerDrofusInterfaceRunsQuery,
  usePostMultiplacerDrofusInterfaceDeleteRunMutation,
  usePostMultiplacerDrofusInterfaceOccurrencesQuery,
  usePostMultiplacerDrofusInterfaceArticlesQuery,
  usePostTdroomUpsertMutation,
  useGetTdroomSingleQuery,
  useGetTdroomAllQuery,
  usePostAddProjectTdRoomsMutation,
  useGetMultiplacerDevicetypesQuery,
  usePostMultiplacerDevicetypesAggregateMutation,
  useGetMultiplacerDevicetypesStatsQuery,
  usePostMlPredictCeilingDevicesMutation,
  useGetMlPingQuery,
  usePostMultiplacerProjectAddProjectMutation,
  useGetMultiplacerProjectsQuery,
  usePostProjectDrofusUpdateSettingsMutation,
  useGetMultiplacerProjectsSingleProjectQuery,
  usePostMultiplacerProjectEditProjectMutation,
  usePostProjectVentilationUpdateSettingsMutation,
  usePostMultiplacerProjectsAddMemberMutation,
  usePostMultiplacerProjectsInviteByEmailMutation,
  usePingQuery,
  useGetFunctionsPingQuery,
  usePostMultiplacerEnrichRoomMutation,
  usePostMultiplacerSyncStartMutation,
  usePostProjectDrofusVerifyConnectionMutation,
  usePostMultiplacerDrofusInterfaceOccurrencesSyncMutation,
  usePostSharedZodPingMutation,
  useGetSharedStaticDeviceTypeSettingsQuery,
  usePostMultiplacerReleaseNotesDeployNotesMutation,
  useGetMultiplacerReleaseNotesPublishedQuery,
  useGetMultiplacerReleaseNotesDeployNotesUnpublishedQuery,
  usePostMultiplacerReleaseNotesPublishMutation,
  useDeleteMultiplacerReleaseNotesDeployNotesByDeployNoteIdChangeItemsAndChangeItemIdMediaMutation,
  useGetMultiplacerReleaseNotesStatusQuery,
  usePostMultiplacerReleaseNotesMarkSeenMutation,
  useGetRoutingGraphListQuery,
  usePostRoutingGraphSaveMutation,
  useDeleteRoutingGraphDeleteMutation,
  useGetMcappsProjectPnsQuery,
} = injectedRtkApi;
